
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea202"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea202"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3jPiW", function(module, exports) {
module.exports = $parcel$import("6z40I").then(()=>parcelRequire('aexh3'));

});

var $e7f55278018167e8$exports = {};
$parcel$extendImportMap({
    "6z40I": "es.95be77cf.js"
});

/*!
 * @georapbox/a-tab-group
 * A custom element to create a group of tabs and tab panels.
 *
 * @version 2.4.1
 * @homepage https://github.com/georapbox/a-tab-group#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $5a53255ef6289be5$var$h = (a = "", t = "")=>{
    let e = typeof a == "string" && a !== "" ? a + "-" : "", s = typeof t == "string" && t !== "" ? "-" + t : "", i = Math.random().toString(36).substring(2, 8);
    return `${e}${i}${s}`;
};
var $5a53255ef6289be5$var$b = (a, t)=>{
    if (Object.prototype.hasOwnProperty.call(t, a)) {
        let e = t[a];
        delete t[a], t[a] = e;
    }
};
var $5a53255ef6289be5$var$E = 0, $5a53255ef6289be5$var$C = `
  :host {
    box-sizing: border-box;
    display: inline-block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.75rem;
    white-space: nowrap;
    cursor: pointer;
  }

  :host([disabled]) .tab {
    opacity: 0.7;
    cursor: not-allowed;
  }

  :host([selected]) .tab {
    color: var(--selected-tab-color);
    background-color: var(--selected-tab-bg-color);
  }

  .tab__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    font-size: inherit;
    cursor: pointer;
  }
`, $5a53255ef6289be5$var$w = document.createElement("template");
$5a53255ef6289be5$var$w.innerHTML = `
  <style>
    ${$5a53255ef6289be5$var$C}
  </style>

  <div part="base" class="tab">
    <slot></slot>
  </div>
`;
var $5a53255ef6289be5$export$6824c350c20eab3a = class a extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$w.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "selected",
            "disabled",
            "closable"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if (t === "selected" && e !== s && (this.setAttribute("aria-selected", this.selected.toString()), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0")), t === "disabled" && e !== s && (this.setAttribute("aria-disabled", this.disabled.toString()), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0")), t === "closable" && e !== s) {
            if (this.closable) {
                let i = document.createElement("span");
                i.className = "tab__close", i.setAttribute("part", "close-tab"), i.innerHTML = '<svg part="close-tab-icon" xmlns="http://www.w3.org/2000/svg" width="0.875em" height="0.875em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/></svg>', this.shadowRoot?.querySelector(".tab")?.appendChild(i), i.addEventListener("click", this.#e);
            } else {
                let i = this.shadowRoot?.querySelector(".tab__close");
                i?.removeEventListener("click", this.#e), i?.remove();
            }
        }
    }
    connectedCallback() {
        this.#s("selected"), this.#s("disabled"), this.#s("closable"), this.id || (this.id = $5a53255ef6289be5$var$h("tab", (++$5a53255ef6289be5$var$E).toString())), this.setAttribute("slot", "tab"), this.setAttribute("role", "tab"), this.setAttribute("aria-selected", "false"), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0");
    }
    disconnectedCallback() {
        this.shadowRoot?.querySelector(".tab__close")?.removeEventListener("click", this.#e);
    }
    get selected() {
        return this.hasAttribute("selected");
    }
    set selected(t) {
        this.toggleAttribute("selected", !!t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get closable() {
        return this.hasAttribute("closable");
    }
    set closable(t) {
        this.toggleAttribute("closable", !!t);
    }
    #e = (t)=>{
        t.stopPropagation(), this.dispatchEvent(new CustomEvent("a-tab-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: this.id
            }
        }));
    };
    #s(t) {
        return $5a53255ef6289be5$var$b(t, this);
    }
    static defineCustomElement(t = "a-tab") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$6824c350c20eab3a.defineCustomElement();
var $5a53255ef6289be5$var$L = 0, $5a53255ef6289be5$var$S = `
  :host {
    box-sizing: border-box;
    display: block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }
`, $5a53255ef6289be5$var$T = document.createElement("template");
$5a53255ef6289be5$var$T.innerHTML = `
  <style>
    ${$5a53255ef6289be5$var$S}
  </style>

  <div part="base" class="tab-panel">
    <slot></slot>
  </div>
`;
var $5a53255ef6289be5$export$185adf5fa2c760b1 = class a extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$T.content.cloneNode(!0));
    }
    connectedCallback() {
        this.setAttribute("slot", "panel"), this.setAttribute("role", "tabpanel"), this.setAttribute("hidden", ""), this.id || (this.id = $5a53255ef6289be5$var$h("panel", (++$5a53255ef6289be5$var$L).toString()));
    }
    static defineCustomElement(t = "a-tab-panel") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$185adf5fa2c760b1.defineCustomElement();
var $5a53255ef6289be5$var$y = 200, $5a53255ef6289be5$var$n = {
    TOP: "top",
    BOTTOM: "bottom",
    START: "start",
    END: "end"
}, $5a53255ef6289be5$var$l = {
    LTR: "ltr",
    RTL: "rtl"
}, $5a53255ef6289be5$var$R = Object.entries($5a53255ef6289be5$var$n).map(([, a])=>a), $5a53255ef6289be5$var$r = {
    AUTO: "auto",
    MANUAL: "manual"
}, $5a53255ef6289be5$var$c = {
    DOWN: "ArrowDown",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    HOME: "Home",
    END: "End",
    ENTER: "Enter",
    SPACE: " "
}, $5a53255ef6289be5$var$x = `
  :host {
    --selected-tab-color: #005fcc;
    --selected-tab-bg-color: transparent;
    --tabs-scroll-behavior: smooth;
    --scroll-button-width: 2.125em;
    --scroll-button-height: 2.125em;
    --scroll-button-inline-offset: 0rem;

    box-sizing: border-box;
    display: block;
    contain: content;
  }

  @media (prefers-reduced-motion: reduce) {
    :host {
      --tabs-scroll-behavior: auto;
    }
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab-group {
    display: flex;
    width: 100%;
  }

  .tab-group__nav {
    position: relative;
  }

  .tab-group__nav--has-scroll-controls {
    padding: 0 calc(var(--scroll-button-width) + var(--scroll-button-inline-offset));
  }

  .tab-group__scroll-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: var(--scroll-button-width);
    height: var(--scroll-button-height);
    padding: 0; /* Required for iOS, otherwise the svg is not visible: https://stackoverflow.com/questions/66532071/flex-svg-behaving-strange-in-ios-safari-14-0-3 */
    border: 0;
    z-index: 1;
    background-color: transparent;
    font-size: inherit;
    cursor: pointer;
    color: currentColor;
  }

  .tab-group__scroll-button--start {
    left: var(--scroll-button-inline-offset);
  }

  .tab-group__scroll-button--end {
    right: var(--scroll-button-inline-offset);
  }

  :host([dir="${$5a53255ef6289be5$var$l.RTL}"]) .tab-group__scroll-button--start,
  :host(:dir(${$5a53255ef6289be5$var$l.RTL})) .tab-group__scroll-button--start {
    right: var(--scroll-button-inline-offset);
    left: auto;
    transform: translateY(-50%) rotate(180deg);
  }

  :host([dir="${$5a53255ef6289be5$var$l.RTL}"]) .tab-group__scroll-button--end,
  :host(:dir(${$5a53255ef6289be5$var$l.RTL})) .tab-group__scroll-button--end {
    left: var(--scroll-button-inline-offset);
    right: auto;
    transform: translateY(-50%) rotate(180deg);
  }

  .tab-group__tabs {
    display: flex;
    padding: 0.25rem;
    overflow-x: auto;
    scroll-behavior: var(--tabs-scroll-behavior);
    scrollbar-width: none;
  }

  .tab-group__tabs::-webkit-scrollbar {
    display: none;
  }

  .tab-group__panels {
    padding: 1rem 0;
  }

  /* placement="top" */
  .tab-group,
  :host([placement="${$5a53255ef6289be5$var$n.TOP}"]) .tab-group {
    flex-direction: column;
  }

  /* placement="bottom" */
  :host([placement="${$5a53255ef6289be5$var$n.BOTTOM}"]) .tab-group {
    flex-direction: column;
  }

  :host([placement="${$5a53255ef6289be5$var$n.BOTTOM}"]) .tab-group__nav {
    order: 1;
  }

  /* placement="start" */
  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }

  /* placement="end" */
  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__nav {
    order: 1;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }
`, $5a53255ef6289be5$var$A = document.createElement("template");
$5a53255ef6289be5$var$A.innerHTML = `
  <style>${$5a53255ef6289be5$var$x}</style>

  <div part="base" class="tab-group">
    <div part="nav" class="tab-group__nav">
      <button type="button" part="scroll-button scroll-button--start" class="tab-group__scroll-button tab-group__scroll-button--start" aria-label="Scroll to start">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </button>

      <div part="tabs" class="tab-group__tabs" role="tablist" tabindex="-1">
        <slot name="tab"></slot>
      </div>

      <button type="button" part="scroll-button scroll-button--end" class="tab-group__scroll-button tab-group__scroll-button--end" aria-label="Scroll to end">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>
    </div>

    <div part="panels" class="tab-group__panels">
      <slot name="panel"></slot>
    </div>
  </div>
`;
var $5a53255ef6289be5$export$4ac05a649254e913 = class a extends HTMLElement {
    #e = null;
    #s = null;
    #l = !1;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$A.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "placement",
            "no-scroll-controls"
        ];
    }
    attributeChangedCallback(t, e, s) {
        t === "placement" && e !== s && this.#i(), t === "no-scroll-controls" && e !== s && this.#i();
    }
    get placement() {
        return this.getAttribute("placement") || $5a53255ef6289be5$var$n.TOP;
    }
    set placement(t) {
        t != null && this.setAttribute("placement", t);
    }
    get noScrollControls() {
        return this.hasAttribute("no-scroll-controls");
    }
    set noScrollControls(t) {
        this.toggleAttribute("no-scroll-controls", !!t);
    }
    get scrollDistance() {
        let t = Number(this.getAttribute("scroll-distance"));
        return Math.abs(t) || $5a53255ef6289be5$var$y;
    }
    set scrollDistance(t) {
        this.setAttribute("scroll-distance", Math.abs(t).toString() || $5a53255ef6289be5$var$y.toString());
    }
    get activation() {
        return this.getAttribute("activation") || $5a53255ef6289be5$var$r.AUTO;
    }
    set activation(t) {
        this.setAttribute("activation", t || $5a53255ef6289be5$var$r.AUTO);
    }
    get noTabCycling() {
        return this.hasAttribute("no-tab-cycling");
    }
    set noTabCycling(t) {
        this.toggleAttribute("no-tab-cycling", !!t);
    }
    connectedCallback() {
        this.#o("placement"), this.#o("noScrollControls"), this.#o("scrollDistance"), this.#o("activation"), this.#o("noTabCycling");
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), i = this.shadowRoot?.querySelector(".tab-group__nav"), o = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.addEventListener("slotchange", this.#n), e?.addEventListener("slotchange", this.#n), s?.addEventListener("click", this.#g), s?.addEventListener("keydown", this.#p), o.forEach((d)=>d.addEventListener("click", this.#f)), this.addEventListener("a-tab-close", this.#m), "ResizeObserver" in window && (this.#e = new ResizeObserver((d)=>{
            this.#s = window.requestAnimationFrame(()=>{
                let v = d?.[0]?.target, g = v?.scrollWidth > v?.clientWidth;
                o.forEach((_)=>_.toggleAttribute("hidden", !g)), i?.part.toggle("nav--has-scroll-controls", g), i?.classList.toggle("tab-group__nav--has-scroll-controls", g);
            });
        })), this.#h(), this.#i();
    }
    disconnectedCallback() {
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), i = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.removeEventListener("slotchange", this.#n), e?.removeEventListener("slotchange", this.#n), s?.removeEventListener("click", this.#g), s?.removeEventListener("keydown", this.#p), i.forEach((o)=>o.removeEventListener("click", this.#f)), this.removeEventListener("a-tab-close", this.#m), this.#c();
    }
    #v() {
        if (!this.#e) return;
        let t = this.shadowRoot?.querySelector(".tab-group__tabs");
        t && (this.#e.unobserve(t), this.#e.observe(t));
    }
    #c() {
        this.#e && (this.#e.disconnect(), this.#s !== null && (window.cancelAnimationFrame(this.#s), this.#s = null));
    }
    #d() {
        return window.CSS.supports("selector(:dir(ltr))") ? this.matches(":dir(ltr)") ? $5a53255ef6289be5$var$l.LTR : $5a53255ef6289be5$var$l.RTL : window.getComputedStyle(this).direction || $5a53255ef6289be5$var$l.LTR;
    }
    #h() {
        this.hidden = this.#t().length === 0;
    }
    #w() {
        let t = this.#t();
        this.#h(), t.forEach((e)=>{
            let s = e.nextElementSibling;
            if (!s || s.tagName.toLowerCase() !== "a-tab-panel") return console.error(`Tab #${e.id} is not a sibling of a <a-tab-panel>`);
            e.setAttribute("aria-controls", s.id), s.setAttribute("aria-labelledby", e.id);
        });
    }
    #T() {
        return Array.from(this.querySelectorAll("a-tab-panel"));
    }
    #t() {
        return Array.from(this.querySelectorAll("a-tab"));
    }
    #b(t) {
        let e = t.getAttribute("aria-controls");
        return this.querySelector(`#${e}`);
    }
    #y() {
        return this.#t().find((e)=>!e.disabled) || null;
    }
    #A() {
        let t = this.#t();
        for(let e = t.length - 1; e >= 0; e--)if (!t[e].disabled) return t[e];
        return null;
    }
    #a() {
        let t = this.#t(), e = this.activation === $5a53255ef6289be5$var$r.MANUAL ? t.findIndex((s)=>s.matches(":focus")) - 1 : t.findIndex((s)=>s.selected) - 1;
        for(; t[(e + t.length) % t.length].disabled;)e--;
        return this.noTabCycling && e < 0 ? null : t[(e + t.length) % t.length];
    }
    #r() {
        let t = this.#t(), e = this.activation === $5a53255ef6289be5$var$r.MANUAL ? t.findIndex((s)=>s.matches(":focus")) + 1 : t.findIndex((s)=>s.selected) + 1;
        for(; t[e % t.length].disabled;)e++;
        return this.noTabCycling && e >= t.length ? null : t[e % t.length];
    }
    #_() {
        let t = this.#t(), e = this.#T();
        t.forEach((s)=>s.selected = !1), e.forEach((s)=>s.hidden = !0);
    }
    #i() {
        let t = this.shadowRoot?.querySelector(".tab-group__nav"), e = this.shadowRoot?.querySelector(".tab-group__tabs"), s = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        this.noScrollControls || this.placement === $5a53255ef6289be5$var$n.START || this.placement === $5a53255ef6289be5$var$n.END ? (this.#c(), s.forEach((i)=>i.hidden = !0), t?.part.remove("nav--has-scroll-controls"), t?.classList.remove("tab-group__nav--has-scroll-controls"), e?.setAttribute("aria-orientation", "vertical")) : (this.#v(), s.forEach((i)=>i.hidden = !1), e?.setAttribute("aria-orientation", "horizontal"));
    }
    #E() {
        let t = this.#t(), e = t.find((s)=>s.selected && !s.disabled) || t.find((s)=>!s.disabled);
        e && (this.#l && !e.selected && this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.#u(e));
    }
    #u(t) {
        this.#_(), t && (t.selected = !0);
        let e = this.#b(t);
        e && (e.hidden = !1);
    }
    #n = (t)=>{
        this.#w(), this.#i(), this.#E(), t.target.name === "tab" && (this.#l = !0);
    };
    #p = (t)=>{
        if (t.target.tagName.toLowerCase() !== "a-tab" || t.altKey) return;
        let e = $5a53255ef6289be5$var$R.includes(this.placement || "") ? this.placement : $5a53255ef6289be5$var$n.TOP, s = [
            $5a53255ef6289be5$var$n.TOP,
            $5a53255ef6289be5$var$n.BOTTOM
        ].includes(e || "") ? "horizontal" : "vertical", i = this.#d(), o = null;
        switch(t.key){
            case $5a53255ef6289be5$var$c.LEFT:
                s === "horizontal" && (o = i === $5a53255ef6289be5$var$l.LTR ? this.#a() : this.#r(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.RIGHT:
                s === "horizontal" && (o = i === $5a53255ef6289be5$var$l.LTR ? this.#r() : this.#a(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.UP:
                s === "vertical" && (o = this.#a(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.DOWN:
                s === "vertical" && (o = this.#r(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.HOME:
                o = this.#y(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $5a53255ef6289be5$var$c.END:
                o = this.#A(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $5a53255ef6289be5$var$c.ENTER:
            case $5a53255ef6289be5$var$c.SPACE:
                o = t.target, o && this.selectTab(o);
                break;
            default:
                return;
        }
        t.preventDefault();
    };
    #g = (t)=>{
        let e = t.target.closest("a-tab");
        e && this.selectTab(e);
    };
    #f = (t)=>{
        let e = t.target.closest(".tab-group__scroll-button"), s = this.shadowRoot?.querySelector(".tab-group__tabs");
        if (!e || !s) return;
        let i = e.classList.contains("tab-group__scroll-button--start"), o = this.#d() === $5a53255ef6289be5$var$l.LTR, d = i ? o ? -1 : 1 : o ? 1 : -1, m = s.scrollLeft;
        s.scrollTo({
            left: m + d * this.scrollDistance
        });
    };
    #m = (t)=>{
        let e = t.target, s = this.#b(e);
        e && (e.remove(), e.selected && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        }))), s && s.tagName.toLowerCase() === "a-tab-panel" && s.remove();
    };
    #o(t) {
        return $5a53255ef6289be5$var$b(t, this);
    }
    selectTabByIndex(t) {
        let s = this.#t()[t];
        s && this.selectTab(s);
    }
    selectTabById(t) {
        let s = this.#t().find((i)=>i.id === t);
        s && this.selectTab(s);
    }
    selectTab(t) {
        let e = this.#t().find((s)=>s.selected);
        !t || t.disabled || t.selected || t.tagName.toLowerCase() !== "a-tab" || (this.#u(t), window.requestAnimationFrame(()=>{
            t.scrollIntoView({
                inline: "nearest",
                block: "nearest"
            }), t.focus();
        }), e && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: t.id
            }
        })));
    }
    static defineCustomElement(t = "a-tab-group") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$4ac05a649254e913.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $cd62c5572235e737$var$h = `
  :host {
    display: inline-block;
  }
`, $cd62c5572235e737$var$r = document.createElement("template");
$cd62c5572235e737$var$r.innerHTML = `
  <style>${$cd62c5572235e737$var$h}</style>
  <slot name="button"><button type="button" part="button"><slot name="button-content">Share</slot></button></slot>
`;
var $cd62c5572235e737$export$30b344bef3e55b67 = class a extends HTMLElement {
    #e;
    #t;
    #r = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($cd62c5572235e737$var$r.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector('slot[name="button"]') || null, this.#t = this.#h();
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, e, i) {
        t === "disabled" && e !== i && this.#t && (this.#t.toggleAttribute("disabled", this.disabled), this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part && this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#s("shareUrl"), this.#s("shareTitle"), this.#s("shareText"), this.#s("shareFiles"), this.#s("disabled"), this.#e?.addEventListener("slotchange", this.#a), this.#t?.addEventListener("click", this.#i);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("slotchange", this.#a), this.#t?.removeEventListener("click", this.#i);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get shareUrl() {
        return this.getAttribute("share-url") || "";
    }
    set shareUrl(t) {
        this.setAttribute("share-url", t);
    }
    get shareTitle() {
        return this.getAttribute("share-title") || "";
    }
    set shareTitle(t) {
        this.setAttribute("share-title", t);
    }
    get shareText() {
        return this.getAttribute("share-text") || "";
    }
    set shareText(t) {
        this.setAttribute("share-text", t);
    }
    get shareFiles() {
        return this.#r;
    }
    set shareFiles(t) {
        Array.isArray(t) && t.length > 0 && (this.#r = t);
    }
    async share() {
        if (!this.disabled) try {
            let t = {};
            this.shareUrl && (t.url = this.shareUrl), this.shareTitle && (t.title = this.shareTitle), this.shareText && (t.text = this.shareText), Array.isArray(this.shareFiles) && this.shareFiles.length > 0 && navigator.canShare && navigator.canShare({
                files: this.shareFiles
            }) && (t.files = this.shareFiles), await navigator.share(t), this.dispatchEvent(new CustomEvent("web-share:success", {
                bubbles: !0,
                composed: !0,
                detail: {
                    shareData: t
                }
            }));
        } catch (t) {
            if (t instanceof Error && t.name === "AbortError") {
                this.dispatchEvent(new CustomEvent("web-share:abort", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
                return;
            }
            this.dispatchEvent(new CustomEvent("web-share:error", {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #i = (t)=>{
        t.preventDefault(), !this.disabled && this.share();
    };
    #a = (t)=>{
        t.target && t.target.name === "button" && (this.#t?.removeEventListener("click", this.#i), this.#t = this.#h(), this.#t && (this.#t.addEventListener("click", this.#i), this.#t.nodeName !== "BUTTON" && !this.#t.hasAttribute("role") && this.#t.setAttribute("role", "button")));
    };
    #h() {
        return this.#e && this.#e.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let i = e[t];
            delete e[t], e[t] = i;
        }
    }
    static defineCustomElement(t = "web-share") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$cd62c5572235e737$export$30b344bef3e55b67.defineCustomElement();


/*!
 * @georapbox/files-dropzone-element
 * A custom element that creates a drag and drop zone for files
 *
 * @version 2.2.0
 * @homepage https://github.com/georapbox/files-dropzone-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $9351176e8d763a78$var$h(o, e = "") {
    if (!e) return !0;
    let t = [
        ...new Set(e.split(",").map((r)=>r.trim()).filter(Boolean))
    ], i = o.type, s = i.replace(/\/.*$/, "");
    for (let r of t)if (r.charAt(0) === ".") {
        if (o.name.toLowerCase().indexOf(r.toLowerCase(), o.name.length - r.length) !== -1) return !0;
    } else if (/\/\*$/.test(r)) {
        if (s === r.replace(/\/.*$/, "")) return !0;
    } else if (i === r) return !0;
    return !1;
}
var $9351176e8d763a78$var$E = new Map([
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]), $9351176e8d763a78$var$f = [
    ".DS_Store",
    "Thumbs.db"
], $9351176e8d763a78$var$z = (o)=>{
    let { name: e } = o;
    if (e && e.lastIndexOf(".") !== -1 && !o.type) {
        let i = (e.split(".").pop() || "").toLowerCase(), s = $9351176e8d763a78$var$E.get(i);
        s && Object.defineProperty(o, "type", {
            value: s,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return o;
}, $9351176e8d763a78$var$g = (o, e)=>{
    let t = $9351176e8d763a78$var$z(o);
    if (typeof t.path != "string") {
        let { webkitRelativePath: i } = o;
        Object.defineProperty(t, "path", {
            value: typeof e == "string" ? e : i || o.name,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return t;
}, $9351176e8d763a78$var$u = async (o)=>await new Promise((e, t)=>{
        o.readEntries(e, t);
    }), $9351176e8d763a78$var$x = async (o)=>{
    let e = [], t = await $9351176e8d763a78$var$u(o);
    for(; t.length > 0;)e.push(...t), t = await $9351176e8d763a78$var$u(o);
    return e;
}, $9351176e8d763a78$var$y = (o)=>new Promise((e, t)=>{
        o.file((i)=>e($9351176e8d763a78$var$g(i, o.fullPath)), t);
    }), $9351176e8d763a78$var$w = async (o)=>{
    let e = [], t = [];
    for (let i of o){
        if (i.kind !== "file") continue;
        let s = i.getAsEntry ? i.getAsEntry() : i.webkitGetAsEntry();
        t.push(s);
    }
    for(; t.length > 0;){
        let i = t.shift();
        if (i) {
            if (i.isFile) {
                let s = await $9351176e8d763a78$var$y(i);
                $9351176e8d763a78$var$f.indexOf(s.name) === -1 && e.push(s);
            } else i.isDirectory && t.push(...await $9351176e8d763a78$var$x(i.createReader()));
        } else continue;
    }
    return e;
}, $9351176e8d763a78$var$m = async (o)=>{
    let e = [];
    for (let t of o)$9351176e8d763a78$var$f.indexOf(t.name) === -1 && e.push($9351176e8d763a78$var$g(t));
    return e;
}, $9351176e8d763a78$var$d = async (o)=>o.dataTransfer ? o.dataTransfer.items ? await $9351176e8d763a78$var$w(o.dataTransfer.items) : await $9351176e8d763a78$var$m(o.dataTransfer.files) : await $9351176e8d763a78$var$m(o.target.files);
var $9351176e8d763a78$var$O = String.raw, $9351176e8d763a78$var$L = String.raw, $9351176e8d763a78$var$b = "files-dropzone", $9351176e8d763a78$var$v = document.createElement("template"), $9351176e8d763a78$var$F = $9351176e8d763a78$var$O`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49, 132, 253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition:
      border var(--dropzone-transition-duration) ease-in-out,
      background-color var(--dropzone-transition-duration) ease-in-out,
      color var(--dropzone-transition-duration) ease-in-out,
      box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$9351176e8d763a78$var$v.innerHTML = $9351176e8d763a78$var$L`
  <style>
    ${$9351176e8d763a78$var$F}
  </style>

  <input type="file" id="file-input" hidden />

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot><span>Drag 'n' drop files here, or click to select files</span></slot>
  </div>
`;
var $9351176e8d763a78$export$6ccd1735166caad9 = class o extends HTMLElement {
    static ERROR_CODES = {
        FILE_DIALOG_OPEN_FAILED: "FILE_DIALOG_OPEN_FAILED",
        FILE_INPUT_CHANGE_FAILED: "FILE_INPUT_CHANGE_FAILED",
        DROP_EVENT_PROCESSING_FAILED: "DROP_EVENT_PROCESSING_FAILED",
        UNKNOWN_ERROR: "UNKNOWN_ERROR"
    };
    static REJECTION_CODES = {
        TOO_MANY_FILES: "TOO_MANY_FILES",
        FILE_TOO_LARGE: "FILE_TOO_LARGE",
        FILE_TOO_SMALL: "FILE_TOO_SMALL",
        INVALID_MIME_TYPE: "INVALID_MIME_TYPE"
    };
    #t = null;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($9351176e8d763a78$var$v.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.getElementById("file-input"), this.#e = this.shadowRoot.getElementById("dropzone"));
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "accept" && t !== i && this.#t && (this.#t.accept = this.accept), e === "disabled" && t !== i && this.#t && (this.#t.disabled = this.disabled, this.disabled ? (this.#e?.removeAttribute("tabindex"), this.#e?.setAttribute("aria-disabled", "true")) : (this.#e?.setAttribute("tabindex", "0"), this.#e?.setAttribute("aria-disabled", "false"))), e === "multiple" && t !== i && this.#t && (this.#t.multiple = this.multiple);
    }
    connectedCallback() {
        this.#o("accept"), this.#o("disabled"), this.#o("maxFiles"), this.#o("maxSize"), this.#o("minSize"), this.#o("multiple"), this.#o("autoFocus"), this.#o("noStyle"), this.#t?.addEventListener("change", this.#s), this.#e?.addEventListener("dragenter", this.#n), this.#e?.addEventListener("dragover", this.#a), this.#e?.addEventListener("dragleave", this.#d), this.#e?.addEventListener("drop", this.#l), this.#e?.addEventListener("click", this.#c), this.#e?.addEventListener("keyup", this.#p), this.autoFocus && this.#e?.focus();
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("change", this.#s), this.#e?.removeEventListener("dragenter", this.#n), this.#e?.removeEventListener("dragover", this.#a), this.#e?.removeEventListener("dragleave", this.#d), this.#e?.removeEventListener("drop", this.#l), this.#e?.removeEventListener("click", this.#c), this.#e?.removeEventListener("keyup", this.#p);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(e) {
        this.setAttribute("accept", e != null ? e.toString() : e);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    get maxFiles() {
        let e = Number(this.getAttribute("max-files")) || 0;
        return e <= 0 ? 1 / 0 : Math.floor(Math.abs(e));
    }
    set maxFiles(e) {
        this.setAttribute("max-files", e != null ? e.toString() : e);
    }
    get maxSize() {
        let e = this.getAttribute("max-size");
        if (e === null) return 1 / 0;
        let t = Number(e);
        return Number.isNaN(t) ? 1 / 0 : t;
    }
    set maxSize(e) {
        this.setAttribute("max-size", e != null ? e.toString() : e);
    }
    get minSize() {
        let e = this.getAttribute("min-size");
        if (e === null) return 0;
        let t = Number(e);
        return Number.isNaN(t) ? 0 : t;
    }
    set minSize(e) {
        this.setAttribute("min-size", e != null ? e.toString() : e);
    }
    get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(e) {
        this.toggleAttribute("multiple", !!e);
    }
    get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(e) {
        this.toggleAttribute("auto-focus", !!e);
    }
    get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(e) {
        this.toggleAttribute("no-style", !!e);
    }
    #i(e, t, i) {
        let s = {
            bubbles: !0,
            composed: !0,
            cancelable: !1,
            ...i,
            detail: t
        }, r = new CustomEvent(`${$9351176e8d763a78$var$b}-${e}`, s);
        return this.dispatchEvent(r);
    }
    #r(e, t) {
        let i = {
            code: e,
            error: t
        };
        this.#i("error", i);
    }
    #s = async (e)=>{
        try {
            this.#h(await $9351176e8d763a78$var$d(e));
        } catch (t) {
            this.#r(o.ERROR_CODES.FILE_INPUT_CHANGE_FAILED, t);
        }
    };
    #n = ()=>{
        this.disabled || this.#i("dragenter");
    };
    #a = (e)=>{
        if (e.preventDefault(), this.disabled) {
            e.dataTransfer.dropEffect = "none";
            return;
        }
        e.dataTransfer.dropEffect = "copy", this.#e && (this.#e.classList.add("dropzone--dragover"), this.#e.part.add("dropzone--dragover")), this.#i("dragover");
    };
    #d = ()=>{
        this.disabled || (this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover")), this.#i("dragleave"));
    };
    #l = async (e)=>{
        if (!this.disabled) {
            e.preventDefault(), this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover"));
            try {
                this.#h(await $9351176e8d763a78$var$d(e));
            } catch (t) {
                this.#r(o.ERROR_CODES.DROP_EVENT_PROCESSING_FAILED, t);
            }
        }
    };
    #c = ()=>{
        this.disabled || this.openFileDialog();
    };
    #p = (e)=>{
        this.disabled || (e.key === " " || e.key === "Enter") && this.openFileDialog();
    };
    #h(e) {
        if (!Array.isArray(e) || !e.length) return;
        let t = [], i = [], s = e.length;
        if (!this.multiple && s > 1) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: o.REJECTION_CODES.TOO_MANY_FILES,
                    message: "Too many files selected. Only 1 file is allowed."
                }
            ]
        });
        else if (this.multiple && s > this.maxFiles) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: o.REJECTION_CODES.TOO_MANY_FILES,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else for (let r of e){
            let l = $9351176e8d763a78$var$h(r, this.accept), c = r.size > this.maxSize, p = r.size < this.minSize;
            if (l && !c && !p) t.push(r);
            else {
                let n = [];
                l || n.push({
                    code: o.REJECTION_CODES.INVALID_MIME_TYPE,
                    message: `File type "${r.type}" is not accepted.`
                }), c && n.push({
                    code: o.REJECTION_CODES.FILE_TOO_LARGE,
                    message: `File size ${r.size} exceeds the maximum size of ${this.maxSize}.`
                }), p && n.push({
                    code: o.REJECTION_CODES.FILE_TOO_SMALL,
                    message: `File size ${r.size} is smaller than the minimum size of ${this.minSize}.`
                }), i.push({
                    file: r,
                    errors: n
                });
            }
        }
        this.#i("drop", {
            acceptedFiles: t,
            rejectedFiles: i
        }), t.length > 0 && this.#i("drop-accepted", {
            acceptedFiles: t
        }), i.length > 0 && this.#i("drop-rejected", {
            rejectedFiles: i
        }), this.#t && (this.#t.value = this.#t.defaultValue);
    }
    openFileDialog() {
        if (!(this.disabled || !this.#t)) {
            if ("showPicker" in HTMLInputElement.prototype && typeof this.#t.showPicker == "function") {
                try {
                    this.#t.showPicker();
                } catch (e) {
                    this.#r(o.ERROR_CODES.FILE_DIALOG_OPEN_FAILED, e);
                }
                return;
            }
            this.#t.click();
        }
    }
    #o(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = $9351176e8d763a78$var$b) {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, o);
    }
};
$9351176e8d763a78$export$6ccd1735166caad9.defineCustomElement();


/*!
 * @georapbox/resize-observer-element
 * A custom element that offers a declarative interface to the ResizeObserver API.
 *
 * @version 2.0.1
 * @homepage https://github.com/georapbox/resize-observer-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $1c2cbcdf680d66d4$var$d = ":host { display: contents; }", $1c2cbcdf680d66d4$var$o = document.createElement("template");
$1c2cbcdf680d66d4$var$o.innerHTML = `
  <style>${$1c2cbcdf680d66d4$var$d}</style>
  <slot></slot>
`;
var $1c2cbcdf680d66d4$export$f0e45424cc896229 = class n extends HTMLElement {
    #e = null;
    #t = null;
    #s = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($1c2cbcdf680d66d4$var$o.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector("slot") ?? null;
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "disabled" && t !== i && (this.disabled ? this.#o() : this.#i());
    }
    connectedCallback() {
        this.#d("disabled"), "ResizeObserver" in window && (this.#t = new ResizeObserver((e)=>{
            this.dispatchEvent(new CustomEvent("resize-observer:resize", {
                bubbles: !0,
                composed: !0,
                detail: {
                    entries: e
                }
            }));
        }), this.disabled || this.#i(), this.#e?.addEventListener("slotchange", this.#n));
    }
    disconnectedCallback() {
        this.#o(), this.#e?.removeEventListener("slotchange", this.#n);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    #i() {
        !this.#e || !this.#t || (this.#s.forEach((e)=>this.#t?.unobserve(e)), this.#s = [], this.#e.assignedElements().forEach((e)=>{
            this.#t?.observe(e), this.#s.push(e);
        }));
    }
    #o() {
        this.#t?.disconnect();
    }
    #n = ()=>{
        this.disabled || this.#i();
    };
    #d(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = "resize-observer") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, n);
    }
};
$1c2cbcdf680d66d4$export$f0e45424cc896229.defineCustomElement();


/*!
 * @georapbox/modal-element
 * A custom element to create a modal, using the native dialog element under the hood.
 *
 * @version 1.11.1
 * @homepage https://github.com/georapbox/modal-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $d9c5053bade2d3f8$var$c = [
    {
        transform: "scale(1)"
    },
    {
        transform: "scale(1.02)"
    },
    {
        transform: "scale(1)"
    }
], $d9c5053bade2d3f8$var$h = {
    duration: 300,
    easing: "cubic-bezier(0.2, 0, 0.38, 0.9)"
}, $d9c5053bade2d3f8$var$m = `
  :host {
    --me-width: 32rem;
    --me-height: fit-content;
    --me-border-color: initial;
    --me-border-style: solid;
    --me-border-width: initial;
    --me-border-radius: 0;
    --me-box-shadow: none;
    --me-background-color: canvas;
    --me-color: canvastext;

    --me-header-spacing: 1rem;
    --me-footer-spacing: 1rem;
    --me-header-background-color: transparent;
    --me-header-color: initial;

    --me-body-spacing: 1rem;
    --me-body-background-color: transparent;
    --me-body-color: initial;
    --me-footer-background-color: transparent;
    --me-footer-color: initial;

    --me-close-padding: 0.4375rem;
    --me-close-border: none;
    --me-close-border-radius: 0;
    --me-close-background-color: transparent;
    --me-close-color: inherit;
    --me-close-font-size: 1rem;

    --me-backdrop-background: rgba(0, 0, 0, 0.5);
    --me-backdrop-filter: none;

    display: contents;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  /* Dialog */
  .dialog {
    --dialog-placement-margin: calc((2em + 6px) / 2);

    width: var(--me-width);
    height: var(--me-height);
    padding: 0;
    border-color: var(--me-border-color);
    border-style: var(--me-border-style);
    border-width: var(--me-border-width);
    border-radius: var(--me-border-radius);
    box-shadow: var(--me-box-shadow);
    background-color: var(--me-background-color);
    color: var(--me-color);
  }

  .dialog[open] {
    display: flex;
  }

  :host([fullscreen]) .dialog {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }

  .dialog::backdrop {
    background: var(--me-backdrop-background, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--me-backdrop-filter, none);
    opacity: 0;
  }

  .dialog[open]::backdrop {
    opacity: 1;
  }

  /* Dialog placement */
  :host(:not([fullscreen])[placement="top-start"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-center"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-end"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center-start"]) .dialog {
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center"]) .dialog {
    margin: auto;
  }

  :host(:not([fullscreen])[placement="center-end"]) .dialog {
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-start"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-center"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-end"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  /* Dialog animations */
  @media (prefers-reduced-motion: no-preference) {
    .dialog:not(.dialog--no-animations),
    .dialog:not(.dialog--no-animations)::backdrop {
      transition: transform 0.3s, opacity 0.3s, display 0.3s allow-discrete, overlay 0.3s allow-discrete;
    }

    /* 1. IS-OPEN STATE */
    .dialog[open]:not(.dialog--no-animations) {
      transform: scale(1);
      opacity: 1;
    }

    /* 2. EXIT STATE */
    .dialog:not(.dialog--no-animations) {
      transform: scale(0.95);
      opacity: 0;
    }

    /* 0. BEFORE-OPEN STATE */
    @starting-style {
      .dialog[open]:not(.dialog--no-animations) {
        transform: scale(0.95);
        opacity: 0;
      }

      .dialog[open]:not(.dialog--no-animations)::backdrop {
        opacity: 0;
      }
    }
  }

  /* Dialog panel, header, body, footer */
  .dialog__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
  }

  .dialog__header {
    display: flex;
    align-items: center;
    padding: var(--me-header-spacing);
    column-gap: 0.5rem;
    background-color: var(--me-header-background-color);
    color: var(--me-header-color);
  }

  :host([no-close-button]) .dialog__header {
    column-gap: 0;
  }

  .dialog__title {
    display: block;
    flex: 1 1 auto;
    padding: 0;
    margin: 0;
  }

  .dialog__body {
    display: block;
    flex: 1 1 auto;
    padding: var(--me-body-spacing);
    overflow: auto;
    background-color: var(--me-body-background-color);
    color: var(--me-body-color);
    overscroll-behavior: contain;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: end;
    padding: var(--me-footer-spacing);
    background-color: var(--me-footer-background-color);
    color: var(--me-footer-color);
  }

  .dialog__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--me-close-padding);
    border: var(--me-close-border);
    border-radius: var(--me-close-border-radius);
    background-color: var(--me-close-background-color);
    color: var(--me-close-color);
    font-size: var(--me-close-font-size);
  }

  .dialog__close:not(:disabled) {
    cursor: pointer;
  }

  .dialog__close:disabled {
    cursor: not-allowed;
  }
`, $d9c5053bade2d3f8$var$r = document.createElement("template");
$d9c5053bade2d3f8$var$r.innerHTML = `
  <style>${$d9c5053bade2d3f8$var$m}</style>

  <dialog part="base" class="dialog">
    <div part="panel" class="dialog__panel" aria-labelledby="title">
      <header part="header" class="dialog__header">
        <slot name="header" part="title" class="dialog__title" id="title"></slot>

        <form method="dialog">
          <button type="submit" part="close" class="dialog__close" aria-label="Close">
            <slot name="close">
              <svg part="close-icon" xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </slot>
          </button>
        </form>
      </header>

      <slot part="body" class="dialog__body"></slot>

      <footer part="footer" class="dialog__footer" hidden>
        <slot name="footer"></slot>
      </footer>
    </div>
  </dialog>
`;
var $d9c5053bade2d3f8$export$32589115725b904b = class i extends HTMLElement {
    static CLOSE_REQUEST_REASONS = {
        CLOSE_BUTTON: "close-button",
        ESCAPE_KEY: "escape-key",
        BACKDROP_CLICK: "backdrop-click",
        EXTERNAL_INVOKER: "external-invoker"
    };
    #e = null;
    #n = null;
    #i = null;
    #o = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($d9c5053bade2d3f8$var$r.content.cloneNode(!0)), this.shadowRoot && (this.#e = this.shadowRoot.querySelector("dialog"), this.#n = this.shadowRoot.querySelector('slot[name="footer"]'), this.#i = this.shadowRoot.querySelector('slot[name="close"]'));
    }
    static get observedAttributes() {
        return [
            "open",
            "no-header",
            "no-animations",
            "no-close-button",
            "close-label"
        ];
    }
    attributeChangedCallback(e, t, o) {
        if (this.#e !== null) {
            if (e === "open" && t !== o && (this.open ? (this.#e.classList.toggle("dialog--no-animations", this.noAnimations), this.#e.showModal(), this.dispatchEvent(new CustomEvent("me-open", {
                bubbles: !0,
                composed: !0,
                detail: {
                    element: this
                }
            })), document.body && !this.preserveOverflow && (document.body.style.overflow = "hidden")) : this.#e.close()), e === "no-header" && t !== o) {
                let n = this.#e.querySelector(".dialog__header");
                n !== null && (n.hidden = this.noHeader);
            }
            if (e === "no-animations" && t !== o && this.#e.classList.toggle("dialog--no-animations", this.noAnimations), e === "no-close-button" && t !== o) {
                let n = this.#e.querySelector(".dialog__close");
                n !== null && (n.hidden = this.noCloseButton);
            }
            e === "close-label" && t !== o && this.#r();
        }
    }
    connectedCallback() {
        this.#t("open"), this.#t("staticBackdrop"), this.#t("noHeader"), this.#t("noAnimations"), this.#t("noCloseButton"), this.#t("fullscreen"), this.#t("preserveOverflow"), this.#t("placement"), this.#t("closeLabel"), this.#e?.addEventListener("click", this.#h), this.#e?.addEventListener("close", this.#l), this.#e?.addEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.addEventListener("submit", this.#c), this.#n?.addEventListener("slotchange", this.#g), this.#i?.addEventListener("slotchange", this.#u), this.addEventListener("command", this.#m);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("click", this.#h), this.#e?.removeEventListener("close", this.#l), this.#e?.removeEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.removeEventListener("submit", this.#c), this.#n?.removeEventListener("slotchange", this.#g), this.#i?.removeEventListener("slotchange", this.#u), this.removeEventListener("command", this.#m), this.#o && (this.#o?.cancel(), this.#o = null);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        this.toggleAttribute("open", !!e);
    }
    get staticBackdrop() {
        return this.hasAttribute("static-backdrop");
    }
    set staticBackdrop(e) {
        this.toggleAttribute("static-backdrop", !!e);
    }
    get noHeader() {
        return this.hasAttribute("no-header");
    }
    set noHeader(e) {
        this.toggleAttribute("no-header", !!e);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(e) {
        this.toggleAttribute("no-animations", !!e);
    }
    get noCloseButton() {
        return this.hasAttribute("no-close-button");
    }
    set noCloseButton(e) {
        this.toggleAttribute("no-close-button", !!e);
    }
    get fullscreen() {
        return this.hasAttribute("fullscreen");
    }
    set fullscreen(e) {
        this.toggleAttribute("fullscreen", !!e);
    }
    get preserveOverflow() {
        return this.hasAttribute("preserve-overflow");
    }
    set preserveOverflow(e) {
        this.toggleAttribute("preserve-overflow", !!e);
    }
    get placement() {
        return this.getAttribute("placement") || "center";
    }
    set placement(e) {
        this.setAttribute("placement", e != null ? e.toString() : e);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(e) {
        this.setAttribute("close-label", e != null ? e.toString() : e);
    }
    #r() {
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__close");
        if (e === null) return;
        (this.#i?.assignedElements() || [])?.some((n)=>n.textContent?.replace(/\s/g, "") !== "") ? e.removeAttribute("aria-label") : e.setAttribute("aria-label", this.closeLabel);
    }
    #s() {
        let e = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        if (this.noAnimations || e || this.#o) return;
        let o = this.#e;
        !o || typeof o.animate != "function" || (this.#o = o.animate($d9c5053bade2d3f8$var$c, $d9c5053bade2d3f8$var$h), this.#o.finished.catch(()=>{}).finally(()=>{
            this.#o = null;
        }));
    }
    #l = ()=>{
        this.open = !1, this.dispatchEvent(new CustomEvent("me-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                element: this
            }
        })), document.body && !this.preserveOverflow && (document.body.style.overflow = "");
    };
    #d = (e)=>{
        let t = this.#a(i.CLOSE_REQUEST_REASONS.ESCAPE_KEY);
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), this.#s());
    };
    #c = (e)=>{
        let t = this.#a(i.CLOSE_REQUEST_REASONS.CLOSE_BUTTON);
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), this.#s());
    };
    #h = (e)=>{
        let { target: t, currentTarget: o } = e, n = t === o, l = t instanceof HTMLElement && t.closest("[data-me-close]") !== null;
        if (!n && !l) return;
        let d = n ? i.CLOSE_REQUEST_REASONS.BACKDROP_CLICK : i.CLOSE_REQUEST_REASONS.EXTERNAL_INVOKER, a = this.#a(d);
        if (this.dispatchEvent(a), a.defaultPrevented || n && this.staticBackdrop) {
            this.#s();
            return;
        }
        this.hide();
    };
    #m = (e)=>{
        switch(e.command){
            case "--me-open":
                if (this.open) return;
                this.show();
                return;
            case "--me-close":
                {
                    if (!this.open) return;
                    let t = this.#a(i.CLOSE_REQUEST_REASONS.EXTERNAL_INVOKER);
                    if (this.dispatchEvent(t), t.defaultPrevented) {
                        this.#s();
                        return;
                    }
                    this.hide();
                    return;
                }
            default:
                return;
        }
    };
    #g = ()=>{
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__footer");
        if (e === null) return;
        let t = this.#n?.assignedNodes(), o = t ? t.length > 0 : !1;
        e.hidden = !o;
    };
    #u = ()=>{
        this.#r();
    };
    #a(e) {
        return new CustomEvent("me-request-close", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: {
                reason: e,
                element: this
            }
        });
    }
    #t(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let o = t[e];
            delete t[e], t[e] = o;
        }
    }
    show() {
        this.open || (this.open = !0);
    }
    hide() {
        this.open && (this.open = !1);
    }
    static defineCustomElement(e = "modal-element") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, i);
    }
};
$d9c5053bade2d3f8$export$32589115725b904b.defineCustomElement();


/*!
 * @georapbox/alert-element
 * A custom HTML element for displaying dismissible alerts and toast notifications.
 *
 * @version 2.0.0
 * @homepage https://github.com/georapbox/alert-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $92e4d942855edcf9$var$y = String.raw;
function $92e4d942855edcf9$var$b() {
    let o = Object.assign(document.createElement("div"), {
        className: "alert-toast-stack"
    }), t = o.attachShadow({
        mode: "open"
    });
    return t.innerHTML = $92e4d942855edcf9$var$y`
    <style>
      :host {
        display: contents;
        box-sizing: border-box;
      }

      :host *,
      :host *::before,
      :host *::after {
        box-sizing: inherit;
      }

      .stack {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 1000;
        width: 30rem;
        max-width: 100%;
        max-height: 100%;
        overflow: auto;
        scrollbar-width: none;
      }

      @media (prefers-reduced-motion: no-preference) {
        .stack {
          scroll-behavior: smooth;
        }
      }

      .stack > ::slotted(*) {
        margin: 1rem;
      }
    </style>

    <div class="stack" part="base"><slot></slot></div>
  `, o;
}
var $92e4d942855edcf9$var$l = class o extends EventTarget {
    #i = !1;
    #t = 0;
    #e = 0;
    #a = 0;
    #n = 0;
    #l = 0;
    constructor(t){
        super();
        let s = {
            elapsed: 0,
            duration: 1 / 0,
            ...t
        }, { elapsed: i, duration: n } = s;
        if (typeof i != "number" || Number.isNaN(i)) throw new TypeError("elapsed option must be a number");
        if (typeof n != "number" || Number.isNaN(n)) throw new TypeError("duration option must be a number");
        this.#i = !1, this.#t = Math.max(0, n), this.#e = Math.min(Math.max(0, i), this.#t), this.#a = this.#e, this.#n = 0, this.#l = this.#e;
    }
    #o(t) {
        this.dispatchEvent(new Event(t));
    }
    #s = ()=>{
        if (!this.#i) return;
        let t = o.now() - this.#n + this.#l;
        this.#e = Math.min(t, this.#t), this.#o("tick"), t < this.#t ? requestAnimationFrame(this.#s) : (this.#i = !1, this.#l = this.#e, this.#o("finish"));
    };
    on(t, e, s) {
        return this.addEventListener(t, e, s), this;
    }
    off(t, e, s) {
        return this.removeEventListener(t, e, s), this;
    }
    start() {
        return this.#i || this.#e >= this.#t ? this : (this.#i = !0, this.#n = o.now(), this.#o("start"), requestAnimationFrame(this.#s), this);
    }
    stop() {
        return this.#i ? (this.#i = !1, this.#l = this.#e, this.#o("stop"), this) : this;
    }
    reset() {
        return this.#i = !1, this.#e = this.#a, this.#l = this.#a, this.#n = 0, this.#o("reset"), this;
    }
    time() {
        return {
            elapsed: this.#e,
            remaining: this.remaining
        };
    }
    get elapsed() {
        return this.#e;
    }
    get remaining() {
        return Math.max(0, this.#t - this.#e);
    }
    get running() {
        return this.#i;
    }
    static now() {
        return "performance" in window ? performance.now() : Date.now();
    }
};
var $92e4d942855edcf9$export$bcaaabdfa905208d = "alert-show", $92e4d942855edcf9$export$81ab4fca8593b3c3 = "alert-after-show", $92e4d942855edcf9$export$226f9005303b5703 = "alert-hide", $92e4d942855edcf9$export$eeb2b20dfb890f89 = "alert-after-hide", $92e4d942855edcf9$export$d331fa5a0216b8f7 = "--alert-show", $92e4d942855edcf9$export$e1d9e4f4c86dcb42 = "--alert-hide", $92e4d942855edcf9$export$bf3772a8f52c594f = "user", $92e4d942855edcf9$export$531831fe78c474f9 = "timeout", $92e4d942855edcf9$export$a813795bcfceac3f = "api", $92e4d942855edcf9$var$k = String.raw, $92e4d942855edcf9$var$L = String.raw, $92e4d942855edcf9$var$r = $92e4d942855edcf9$var$b(), $92e4d942855edcf9$var$T = $92e4d942855edcf9$var$L`
  :host {
    --alert-border-radius: 0.25rem;
    --alert-top-border-width: 0.1875rem;
    --alert-countdown-height: 0.1875rem;
    --alert-fg-color: #3f3f46;
    --alert-bg-color: #ffffff;
    --alert-border-color: #e4e4e7;
    --alert-base-variant-color: var(--alert-fg-color);
    --alert-info-variant-color: #0584c7;
    --alert-success-variant-color: #16a34a;
    --alert-neutral-variant-color: #52525b;
    --alert-warning-variant-color: #d87708;
    --alert-danger-variant-color: #dc2626;
    display: contents;
    box-sizing: border-box;
  }

  @media (prefers-color-scheme: dark) {
    :host {
      --alert-fg-color: #b6b6be;
      --alert-bg-color: #252528;
      --alert-border-color: #36363a;
      --alert-info-variant-color: #27bbfc;
      --alert-success-variant-color: #3ae075;
      --alert-neutral-variant-color: #8e8e9a;
      --alert-warning-variant-color: #ffbd11;
      --alert-danger-variant-color: #fe5c5c;
    }
  }

  :host([variant='info']) {
    --alert-base-variant-color: var(--alert-info-variant-color);
  }
  :host([variant='success']) {
    --alert-base-variant-color: var(--alert-success-variant-color);
  }
  :host([variant='neutral']) {
    --alert-base-variant-color: var(--alert-neutral-variant-color);
  }
  :host([variant='warning']) {
    --alert-base-variant-color: var(--alert-warning-variant-color);
  }
  :host([variant='danger']) {
    --alert-base-variant-color: var(--alert-danger-variant-color);
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  .alert {
    position: relative;
    display: flex;
    align-items: center;
    margin: inherit;
    border: 1px solid var(--alert-border-color);
    border-top-width: var(--alert-top-border-width);
    border-top-color: var(--alert-base-variant-color);
    border-radius: var(--alert-border-radius);
    overflow: hidden;
    background-color: var(--alert-bg-color);
  }

  :host([countdown]) .alert {
    padding-bottom: var(--alert-countdown-height);
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    color: var(--alert-base-variant-color);
    font-size: inherit;
    line-height: 0;
  }

  .alert__icon ::slotted(*) {
    margin-inline-start: 1rem;
  }

  .alert__message {
    flex: 1 1 auto;
    padding: 1.25rem;
    overflow: hidden;
    color: var(--alert-fg-color);
    line-height: 1.5;
  }

  .alert__close {
    display: flex;
    align-items: center;
    margin-inline-end: 1rem;
    padding: 0.5rem;
    border: none;
    line-height: 0;
    background: transparent;
    color: var(--alert-fg-color);
    font-size: inherit;
    cursor: pointer;
  }

  :host(:not([closable])) .alert__close {
    display: none !important;
  }

  .alert__countdown {
    position: absolute;
    bottom: 0;
    left: 0;
    overflow: hidden;
    width: 100%;
    height: var(--alert-countdown-height);
    background-color: var(--alert-border-color);
  }

  .alert__countdown-elapsed {
    width: 100%;
    height: 100%;
    background-color: var(--alert-base-variant-color);
    transform-origin: left center;
    will-change: transform;
  }

  .alert__countdown-elapsed:dir(rtl) {
    transform-origin: right center;
  }
`, $92e4d942855edcf9$var$_ = document.createElement("template");
$92e4d942855edcf9$var$_.innerHTML = $92e4d942855edcf9$var$k`
  <style>
    ${$92e4d942855edcf9$var$T}
  </style>

  <div class="alert" part="base" hidden>
    <div class="alert__icon" part="icon">
      <slot name="icon"></slot>
    </div>
    <div class="alert__message" part="message"><slot></slot></div>
    <button type="button" class="alert__close" part="close" aria-label="Close">
      <slot name="close">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1em"
          height="1em"
          fill="currentColor"
          viewBox="0 0 16 16"
          aria-hidden="true"
        >
          <path
            d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"
          />
        </svg>
      </slot>
    </button>
    <div class="alert__countdown" part="countdown" hidden>
      <div class="alert__countdown-elapsed" part="countdown-elapsed"></div>
    </div>
  </div>
`;
var $92e4d942855edcf9$export$d43a820132db491 = class o extends HTMLElement {
    #i = !1;
    #t = null;
    #e = null;
    #a = null;
    #n = null;
    #l;
    static customAnimations;
    #o = $92e4d942855edcf9$export$a813795bcfceac3f;
    #s = null;
    #b = null;
    #h = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($92e4d942855edcf9$var$_.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "open",
            "duration",
            "announce",
            "close-label",
            "countdown",
            "focusable"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if (!(!this.#i || e === s)) switch(t){
            case "open":
                this.open ? (this.duration !== 1 / 0 && this.#s?.start(), this.#t?.removeAttribute("hidden"), this.#h?.style.setProperty("transform", "scaleX(1)"), this.#f($92e4d942855edcf9$export$bcaaabdfa905208d), this.#k(this.#t)?.finished.finally(()=>{
                    this.#f($92e4d942855edcf9$export$81ab4fca8593b3c3);
                })) : (this.duration !== 1 / 0 && this.#s?.reset(), this.#f($92e4d942855edcf9$export$226f9005303b5703, {
                    reason: this.#o
                }), this.#L(this.#t)?.finished.finally(()=>{
                    this.#t?.setAttribute("hidden", ""), this.#f($92e4d942855edcf9$export$eeb2b20dfb890f89, {
                        reason: this.#o
                    }), this.#o = $92e4d942855edcf9$export$a813795bcfceac3f;
                }));
                break;
            case "duration":
                this.#s?.stop().off("tick", this.#c).off("finish", this.#d), this.#s = new $92e4d942855edcf9$var$l({
                    duration: this.duration
                }).on("tick", this.#c).on("finish", this.#d), this.open && this.duration !== 1 / 0 && !this.#_() && this.#s.start(), this.duration === 1 / 0 && this.#h?.style.setProperty("transform", "scaleX(1)");
                break;
            case "close-label":
                this.#p();
                break;
            case "announce":
                this.announce !== "none" ? this.#t?.setAttribute("role", this.announce) : this.#t?.removeAttribute("role");
                break;
            case "countdown":
                this.#b?.toggleAttribute("hidden", !this.countdown);
                break;
            case "focusable":
                this.focusable ? this.#t?.setAttribute("tabindex", "0") : this.#t?.removeAttribute("tabindex");
                break;
            default:
                break;
        }
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(t) {
        this.toggleAttribute("open", !!t);
    }
    get variant() {
        return this.getAttribute("variant") || "";
    }
    set variant(t) {
        this.setAttribute("variant", t);
    }
    get announce() {
        let t = this.getAttribute("announce") ?? "";
        return this.#y(t) ? t : "none";
    }
    set announce(t) {
        this.setAttribute("announce", t != null ? t.toString() : t);
    }
    get closable() {
        return this.hasAttribute("closable");
    }
    set closable(t) {
        this.toggleAttribute("closable", !!t);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(t) {
        this.setAttribute("close-label", t != null ? t.toString() : t);
    }
    get duration() {
        let t = this.getAttribute("duration");
        if (t === null || t === "") return 1 / 0;
        let e = Number(t);
        return e <= 0 ? 10 : Number.isNaN(e) ? 1 / 0 : e;
    }
    set duration(t) {
        this.setAttribute("duration", t != null ? t.toString() : t);
    }
    get countdown() {
        return this.hasAttribute("countdown");
    }
    set countdown(t) {
        this.toggleAttribute("countdown", !!t);
    }
    get focusable() {
        return this.hasAttribute("focusable");
    }
    set focusable(t) {
        this.toggleAttribute("focusable", !!t);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(t) {
        this.toggleAttribute("no-animations", !!t);
    }
    get customAnimations() {
        return this.#l;
    }
    set customAnimations(t) {
        this.#l = t;
    }
    connectedCallback() {
        this.#r("open"), this.#r("variant"), this.#r("announce"), this.#r("closable"), this.#r("closeLabel"), this.#r("duration"), this.#r("countdown"), this.#r("focusable"), this.#r("noAnimations"), this.#r("customAnimations"), this.#t = this.shadowRoot?.querySelector(".alert") ?? null, this.#e = this.shadowRoot?.querySelector(".alert__close") ?? null, this.#a = this.shadowRoot?.querySelector('slot[name="close"]') ?? null, this.#b = this.shadowRoot?.querySelector(".alert__countdown") ?? null, this.#h = this.shadowRoot?.querySelector(".alert__countdown-elapsed") ?? null, this.#e?.addEventListener("click", this.#v), this.#a?.addEventListener("slotchange", this.#g), this.addEventListener("mouseenter", this.#u), this.addEventListener("mouseleave", this.#m), this.addEventListener("focusin", this.#u), this.addEventListener("focusout", this.#m), this.addEventListener("command", this.#w), this.#s = new $92e4d942855edcf9$var$l({
            duration: this.duration
        }).on("tick", this.#c).on("finish", this.#d), this.open ? (this.duration !== 1 / 0 && this.#s?.start(), this.#t?.removeAttribute("hidden")) : this.#t?.setAttribute("hidden", ""), this.closeLabel && this.#p(), this.announce !== "none" ? this.#t?.setAttribute("role", this.announce) : this.#t?.removeAttribute("role"), this.focusable ? this.#t?.setAttribute("tabindex", "0") : this.#t?.removeAttribute("tabindex"), this.#b?.toggleAttribute("hidden", !this.countdown), this.#i = !0;
    }
    disconnectedCallback() {
        this.#i = !1, this.#s?.stop().off("tick", this.#c).off("finish", this.#d), this.#s = null, this.#e?.removeEventListener("click", this.#v), this.#a?.removeEventListener("slotchange", this.#g), this.removeEventListener("mouseenter", this.#u), this.removeEventListener("mouseleave", this.#m), this.removeEventListener("focusin", this.#u), this.removeEventListener("focusout", this.#m), this.removeEventListener("command", this.#w);
    }
    connectedMoveCallback() {}
    #y(t) {
        return t === "none" || t === "status" || t === "alert" || t === "alertdialog";
    }
    #c = (t)=>{
        if (!this.countdown || !this.#h) return;
        let { remaining: e } = t.currentTarget, s = e / this.duration;
        this.#h.style.transform = `scaleX(${s})`;
    };
    #d = ()=>{
        this.#o = $92e4d942855edcf9$export$531831fe78c474f9, this.open = !1;
    };
    #v = ()=>{
        this.closable && (this.#o = $92e4d942855edcf9$export$bf3772a8f52c594f, this.open = !1);
    };
    #u = ()=>{
        !this.open || this.duration === 1 / 0 || this.#s?.stop();
    };
    #m = ()=>{
        !this.open || this.duration === 1 / 0 || this.#_() || this.#s?.start();
    };
    #g = ()=>{
        this.#p();
    };
    #w = (t)=>{
        switch(t.command){
            case $92e4d942855edcf9$export$d331fa5a0216b8f7:
                this.open = !0;
                break;
            case $92e4d942855edcf9$export$e1d9e4f4c86dcb42:
                this.#o = $92e4d942855edcf9$export$a813795bcfceac3f, this.open = !1;
                break;
            default:
                break;
        }
    };
    #p() {
        if (!this.#e) return;
        (this.#a?.assignedElements() || [])?.some((s)=>s.textContent?.replace(/\s/g, "") !== "") ? this.#e.removeAttribute("aria-label") : this.#e.setAttribute("aria-label", this.closeLabel);
    }
    #E() {
        let t = window.matchMedia("(prefers-reduced-motion: reduce)").matches, e = {
            show: {
                keyframes: [
                    {
                        opacity: 0,
                        transform: "scale(0.9)"
                    },
                    {
                        opacity: 1,
                        transform: "scale(1)"
                    }
                ],
                options: {
                    duration: 250,
                    easing: "ease"
                }
            },
            hide: {
                keyframes: [
                    {
                        opacity: 1,
                        transform: "scale(1)"
                    },
                    {
                        opacity: 0,
                        transform: "scale(0.9)"
                    }
                ],
                options: {
                    duration: 250,
                    easing: "ease"
                }
            }
        }, s = this.customAnimations || o.customAnimations || {}, i = t || this.noAnimations || this.customAnimations === null || o.customAnimations === null, n = (a)=>{
            let c = s[a]?.options ?? {}, f = e[a].options;
            return {
                ...f,
                ...c,
                duration: i ? 0 : c.duration ?? f.duration
            };
        };
        return {
            show: {
                keyframes: s.show?.keyframes ?? e.show.keyframes,
                options: n("show")
            },
            hide: {
                keyframes: s.hide?.keyframes ?? e.hide.keyframes,
                options: n("hide")
            }
        };
    }
    #k(t) {
        let { keyframes: e, options: s } = this.#E().show;
        return t?.animate(e, s);
    }
    #L(t) {
        let { keyframes: e, options: s } = this.#E().hide;
        return t?.animate(e, s);
    }
    #f(t, e = null) {
        let s = {
            bubbles: !0,
            composed: !0,
            detail: e
        }, i = new CustomEvent(t, s);
        this.dispatchEvent(i);
    }
    #A(t, e) {
        return new Promise((s)=>{
            let i = (n)=>{
                n.target === t && s();
            };
            t.addEventListener(e, i, {
                once: !0
            });
        });
    }
    #_() {
        return this.matches(":focus-within");
    }
    show() {
        return this.open ? Promise.resolve() : (this.open = !0, this.#A(this, $92e4d942855edcf9$export$81ab4fca8593b3c3));
    }
    hide() {
        return this.open ? (this.open = !1, this.#A(this, $92e4d942855edcf9$export$eeb2b20dfb890f89)) : Promise.resolve();
    }
    toast(t = {}) {
        if (t = {
            forceRestart: !1,
            ...t
        }, this.#n) {
            if (!t.forceRestart) return this.#n.promise;
            this.#n.resolve(), this.#n.cleanup();
        }
        let s = ()=>{}, i = new Promise((c)=>s = c), n = ()=>{
            this.#n?.resolve(), this.#n?.cleanup();
        };
        this.#n = {
            promise: i,
            resolve: s,
            cleanup: ()=>{
                this.removeEventListener($92e4d942855edcf9$export$eeb2b20dfb890f89, n), this.parentNode === $92e4d942855edcf9$var$r && $92e4d942855edcf9$var$r.removeChild(this), $92e4d942855edcf9$var$r.childElementCount === 0 && $92e4d942855edcf9$var$r.remove(), this.open = !1, this.#n = null;
            }
        }, $92e4d942855edcf9$var$r.parentElement || document.body.append($92e4d942855edcf9$var$r), $92e4d942855edcf9$var$r.appendChild(this), this.#t?.setAttribute("data-toast", ""), this.open = !0;
        let a = $92e4d942855edcf9$var$r.shadowRoot?.querySelector(".stack");
        return a?.scrollTo({
            top: a.scrollHeight
        }), this.addEventListener($92e4d942855edcf9$export$eeb2b20dfb890f89, n, {
            once: !0
        }), i;
    }
    #r(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let s = e[t];
            delete e[t], e[t] = s;
        }
    }
    static define(t = "alert-element") {
        typeof window > "u" || window.customElements.get(t) || window.customElements.define(t, o);
    }
};
$92e4d942855edcf9$export$d43a820132db491.define();


/**
 * Clamps number within the inclusive `min` and `max` bounds,
 * making sure it does not go beyond them on either side.
 * If `min` is greater than `max` the parameters are swapped to support inverted ranges.
 *
 * @param {number} value - The number to clamp.
 * @param {number} lower - The lower bound.
 * @param {number} upper - The upper bound.
 * @throws {TypeError} - If one or more of the arguments passed is not a number.
 * @returns {number} The clamped number.
 * @example
 *
 * clamp(10, -5, 5);
 * // => 5
 *
 * clamp(-10, -5, 5);
 * // => -5
 *
 * clamp(-15, 0, 100);
 * // => 0
 *
 * clamp(120, 0, 100);
 * // => 100
 *
 * clamp(-5, NaN, 5); // If any of lower or upper bound are `NaN`, they will be converted to `0`.
 * // => 0
 *
 * clamp(120, 100, 0); // The order of lower and upper bounds is reversed (100 > 0)
 * // => 100
 */ function $66c9ab5a0d7cff10$export$7d15b64cf5a3a4c4(value, lower, upper) {
    if (Number.isNaN(lower)) lower = 0;
    if (Number.isNaN(upper)) upper = 0;
    return Math.min(Math.max(value, Math.min(lower, upper)), Math.max(lower, upper));
}


const $80a69c009606e43c$var$styles = /* css */ `
  :host { display: block; box-sizing: border-box; }
  :host *, :host *::before, :host *::after { box-sizing: border-box; }
  :host([hidden]), [hidden], ::slotted([hidden]) { display: none; }
  video { display: block; }
  #output:empty { display: none; }
`;
const $80a69c009606e43c$var$template = document.createElement('template');
$80a69c009606e43c$var$template.innerHTML = /* html */ `
  <style>${$80a69c009606e43c$var$styles}</style>
  <div part="actions-container"><slot name="actions"></slot></div>
  <slot></slot>
`;
class $80a69c009606e43c$export$682e9ed90a89bb4a extends HTMLElement {
    #supportedConstraints = {};
    #stream = null;
    #videoEl = null;
    constructor(){
        super();
        this.#supportedConstraints = this.getSupportedConstraints();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($80a69c009606e43c$var$template.content.cloneNode(true));
        }
    }
    static get observedAttributes() {
        return [
            'no-image',
            'pan',
            'tilt',
            'zoom',
            'torch'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isConnected) return;
        const trackCapabilities = this.getTrackCapabilities();
        if (name === 'zoom' && oldValue !== newValue && 'zoom' in this.#supportedConstraints) {
            const zoomInAllowedRange = 'zoom' in trackCapabilities && trackCapabilities.zoom?.min && trackCapabilities.zoom?.max ? this.zoom >= trackCapabilities.zoom.min && this.zoom <= trackCapabilities.zoom.max : false;
            if (typeof this.zoom === 'number' && zoomInAllowedRange) this.#applyConstraint('zoom', this.zoom);
        }
        if (name === 'torch' && oldValue !== newValue && 'torch' in this.#supportedConstraints) this.#applyConstraint('torch', this.torch);
    }
    async connectedCallback() {
        this.#upgradeProperty('autoPlay');
        this.#upgradeProperty('facingMode');
        this.#upgradeProperty('zoom');
        this.#upgradeProperty('torch');
        this.#initializeVideoElement();
        this.#videoEl?.addEventListener('loadedmetadata', this.#onVideoLoadedMetaData);
        if (!$80a69c009606e43c$export$682e9ed90a89bb4a.isSupported()) return this.#dispatchError('initialization', 'not-supported', new Error('MediaDevices.getUserMedia() is not supported in this browser'));
        if (this.autoPlay) this.startVideoStream();
    }
    disconnectedCallback() {
        this.stopVideoStream();
        this.#videoEl?.removeEventListener('loadedmetadata', this.#onVideoLoadedMetaData);
    }
    get autoPlay() {
        return this.hasAttribute('auto-play');
    }
    set autoPlay(value) {
        this.toggleAttribute('auto-play', !!value);
    }
    get facingMode() {
        const value = this.getAttribute('facing-mode');
        if (value !== 'user') return 'environment';
        return value;
    }
    set facingMode(value) {
        this.setAttribute('facing-mode', value);
    }
    get zoom() {
        return Number(this.getAttribute('zoom')) || 1;
    }
    set zoom(value) {
        this.setAttribute('zoom', value != null ? value.toString() : value);
    }
    get torch() {
        return this.hasAttribute('torch');
    }
    set torch(value) {
        this.toggleAttribute('torch', !!value);
    }
    get loading() {
        return this.hasAttribute('loading');
    }
    /**
   * Creates the video element after the custom element is connected.
   *
   * This ensures the media element is initialized while connected to the
   * document, avoiding browser-specific playback issues caused by creating it
   * earlier. The element is created only once and reused if the component
   * reconnects.
   */ #initializeVideoElement() {
        if (this.#videoEl) return;
        const video = document.createElement('video');
        video.setAttribute('part', 'video');
        video.setAttribute('playsinline', '');
        video.setAttribute('muted', '');
        video.setAttribute('disablepictureinpicture', '');
        this.shadowRoot?.prepend(video);
        this.#videoEl = video;
    }
    /**
   * Dispatches an error event.
   *
   * @param {string} source - The source of the error.
   * @param {string} reason - The reason for the error.
   * @param {Error} error - The error object.
   */ #dispatchError(source, reason, error) {
        this.#emitEvent('video-capture-error', {
            source: source,
            reason: reason,
            error: error
        });
    }
    /**
   * Handles the loadedmetadata event of the video element.
   *
   * @param {Event} evt - The event object.
   */ #onVideoLoadedMetaData = async (evt)=>{
        const video = evt.target;
        try {
            await video.play();
            this.#emitEvent('video-capture-play', {
                video: video
            });
        } catch (error) {
            const reason = error instanceof DOMException && error.name === 'NotAllowedError' ? 'user-gesture-required' : 'playback-failed';
            this.#dispatchError('playback', reason, error);
        } finally{
            this.removeAttribute('loading');
        }
    };
    /**
   * Applies a constraint to the video track.
   *
   * @param {string} constraint - The name of the constraint.
   * @param {any} value - The value of the constraint.
   */ #applyConstraint(constraint, value) {
        if (!this.#stream) return;
        const [track] = this.#stream.getVideoTracks();
        const trackCapabilities = this.getTrackCapabilities();
        const trackSettings = this.getTrackSettings();
        const constraintValue = constraint === 'pan' || constraint === 'tilt' || constraint === 'zoom' ? (0, $66c9ab5a0d7cff10$export$7d15b64cf5a3a4c4)(Number(value), trackCapabilities[constraint]?.min || 1, trackCapabilities[constraint]?.max || 1) : value;
        if (constraint in trackSettings) track.applyConstraints({
            advanced: [
                {
                    [constraint]: constraintValue
                }
            ]
        }).catch(()=>{
        // Fail silently...
        });
    }
    /**
   * Dispatches a custom event with the given name.
   *
   * @param {string} eventName - The name of the event to dispatch.
   * @param {Nullable<any>} detail - The detail object to include with the event.
   */ #emitEvent(eventName, detail = null) {
        const options = {
            bubbles: true,
            composed: true,
            detail: detail
        };
        const evt = new CustomEvent(eventName, options);
        this.dispatchEvent(evt);
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and
   * set a value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would
   * miss that property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {string} prop - The property to upgrade.
   */ #upgradeProperty(prop) {
        if (Object.prototype.hasOwnProperty.call(this, prop)) {
            const value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }
    /**
   * Starts the video stream.
   *
   * @param {string} [videoInputId] - The video input device ID.
   * @returns Promise<boolean> Resolves to `true` if the video stream started successfully, `false` otherwise.
   */ async startVideoStream(videoInputId) {
        if (!$80a69c009606e43c$export$682e9ed90a89bb4a.isSupported() || this.#stream) return false;
        this.setAttribute('loading', '');
        const constraints = {
            video: {
                facingMode: {
                    ideal: this.facingMode
                },
                pan: true,
                tilt: true,
                zoom: true,
                torch: this.torch
            },
            audio: false
        };
        if (typeof videoInputId === 'string' && videoInputId.trim().length > 0) constraints.video.deviceId = {
            exact: videoInputId
        };
        if (typeof this.cameraResolution === 'string' && this.cameraResolution.trim().length > 0) {
            const [width = 0, height = 0] = this.cameraResolution.split('x').map((x)=>Number(x));
            if (width > 0 && height > 0) {
                constraints.video.width = width;
                constraints.video.height = height;
            }
        }
        try {
            this.#stream = await navigator.mediaDevices.getUserMedia(constraints);
            if (this.#videoEl) this.#videoEl.srcObject = this.#stream;
            this.#applyConstraint('pan', this.pan);
            this.#applyConstraint('tilt', this.tilt);
            this.#applyConstraint('zoom', this.zoom);
            return true;
        } catch (error) {
            const reason = error instanceof DOMException && error.name === 'NotAllowedError' ? 'camera-access-denied' : 'camera-failed';
            this.#dispatchError('camera', reason, error);
            this.removeAttribute('loading');
            return false;
        }
    }
    /**
   * Restarts the video stream.
   *
   * @param {string} [videoInputId] - The video input device ID.
   */ restartVideoStream(videoInputId) {
        if (this.#stream && this.#videoEl) this.stopVideoStream();
        this.startVideoStream(videoInputId);
    }
    /**
   * Stops the video stream.
   */ stopVideoStream() {
        if (!this.#videoEl || !this.#stream) return;
        const [track] = this.#stream.getVideoTracks();
        track?.stop();
        this.#videoEl.srcObject = null;
        this.#stream = null;
    }
    /**
   * Starts playback of the current video stream.
   *
   * This may need to be called directly from a user interaction when
   * autoplay is blocked by the browser.
   *
   * @param {options} [options] - The options for playing the video.
   * @param {boolean} [options.emit=false] - Whether to emit a custom event after playing the video.
   * @returns {Promise<void>} A promise that resolves when the video starts playing, or rejects if there is an error.
   */ async playVideo(options = {}) {
        const { emit: emit = false } = options;
        if (!this.#videoEl || !this.#stream) return;
        try {
            await this.#videoEl.play();
            if (emit) this.#emitEvent('video-capture-play', {
                video: this.#videoEl
            });
        } catch (error) {
            const reason = error instanceof DOMException && error.name === 'NotAllowedError' ? 'user-gesture-required' : 'playback-failed';
            this.#dispatchError('playback', reason, error);
        }
    }
    /**
   * Pauses the current video stream.
   */ stopVideo() {
        if (!this.#videoEl || !this.#stream) return;
        this.#videoEl.pause();
    }
    /**
   * Returns an object based on the `MediaTrackSupportedConstraints` dictionary,
   * whose member fields each specify one ofthe constrainable properties the user agent understands.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaDevices/getSupportedConstraints
   * @returns {MediaTrackSupportedConstraints | {}} The supported constraints or an empty object if the API is not supported.
   */ getSupportedConstraints() {
        if (!$80a69c009606e43c$export$682e9ed90a89bb4a.isSupported()) return {};
        return navigator.mediaDevices.getSupportedConstraints() || {};
    }
    /**
   * Returns a `MediaTrackCapabilities` object which specifies the values or range of values
   * which each constrainable property, based upon the platform and user agent.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaStreamTrack/getCapabilities
   * @returns {MediaTrackCapabilities | {}} The track capabilities or an empty object if the API is not supported.
   */ getTrackCapabilities() {
        if (!this.#stream) return {};
        const [track] = this.#stream.getVideoTracks();
        if (track && typeof track.getCapabilities === 'function') return track.getCapabilities() || {};
        return {};
    }
    /**
   * Returns a `MediaTrackSettings` object containing the current values of each of
   * the constrainable properties for the current MediaStreamTrack.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaStreamTrack/getSettings
   * @returns {MediaTrackSettings | {}} The track settings or an empty object if the API is not supported.
   */ getTrackSettings() {
        if (!this.#stream) return {};
        const [track] = this.#stream.getVideoTracks();
        if (track && typeof track.getSettings === 'function') return track.getSettings() || {};
        return {};
    }
    /**
   * Gets the list of available video input devices.
   *
   * @returns {Promise<MediaDeviceInfo[]>} A promise that resolves to an array of video input devices.
   */ static async getVideoInputDevices() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return [];
        const devices = await navigator.mediaDevices.enumerateDevices() || [];
        return devices.filter((device)=>device.kind === 'videoinput' && !!device.deviceId);
    }
    /**
   * Checks if the `MediaDevices.getUserMedia()` method is supported.
   *
   * @returns {boolean} `true` if the method is supported, `false` otherwise.
   */ static isSupported() {
        return Boolean(navigator.mediaDevices?.getUserMedia);
    }
    /**
   * Defines a custom element with the given name.
   * The name must contain a dash (-).
   *
   * @param {string} [elementName='video-capture'] - The name of the custom element.
   */ static define(elementName = 'video-capture') {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $80a69c009606e43c$export$682e9ed90a89bb4a);
    }
}


/**
 * Displays a toast notification.
 *
 * @param {string} message - The message to display in the toast.
 * @param {Object} [options] - The options for the toast notification.
 * @param {number} [options.duration=5000] - Duration in milliseconds before the toast disappears.
 * @param {string} [options.variant='neutral'] - The variant of the toast (e.g., 'success', 'danger', 'info').
 * @param {boolean} [options.trustDangerousInnerHTML=false] - Whether to trust dangerous HTML in the message.
 * @returns {Promise<AlertElement>} A promise that resolves to the alert element.
 */ function $1531977e7a058bbb$export$cbcbdc571577a620(message, options = {}) {
    const defaults = {
        duration: 5000,
        variant: 'neutral',
        countdown: false,
        announce: 'status',
        icon: ''
    };
    const opts = {
        ...defaults,
        ...options
    };
    const icons = {
        info: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
      </svg>
    `,
        success: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
      </svg>
    `,
        warning: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
      </svg>
    `,
        danger: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
      </svg>
    `
    };
    const icon = icons[opts.icon || opts.variant] || '';
    const alert = Object.assign(document.createElement('alert-element'), {
        closable: true,
        duration: opts.duration,
        variant: opts.variant,
        countdown: opts.countdown,
        announce: opts.announce,
        innerHTML: `${icon ? `<span slot="icon">${icon}</span>` : ''}${opts.trustDangerousInnerHTML ? message : $1531977e7a058bbb$var$escapeHtml(message)}`
    });
    return alert.toast();
}
function $1531977e7a058bbb$var$escapeHtml(html) {
    const div = document.createElement('div');
    div.textContent = html;
    return div.innerHTML;
}


/**
 * Toggles the torch button status.
 * The torch button has two icons, one for on and one for off.
 * This function toggles the visibility of the icons based on the torch state and updates the button title.
 *
 * @param {HTMLButtonElement} buttonEl - The torch button element.
 * @param {boolean} isTorchOn - The torch state.
 */ function $1352c50fc3b67223$export$d1bd0b12fe0d046(options = {}) {
    const defaults = {
        el: document.getElementById('torchButton'),
        isTorchOn: false
    };
    const { el: el, isTorchOn: isTorchOn } = {
        ...defaults,
        ...options
    };
    const iconPaths = el.querySelectorAll('svg path');
    if (iconPaths.length !== 2) return;
    iconPaths[0].style.display = isTorchOn ? 'none' : 'block';
    iconPaths[1].style.display = isTorchOn ? 'block' : 'none';
    el.setAttribute('aria-label', `Turn ${isTorchOn ? 'off' : 'on'} flash`);
}


const $f272c8d1b34cbe13$var$shouldLog = false;
const $f272c8d1b34cbe13$export$bef1f36f5486a6a3 = {
    info: (...args)=>{
        $f272c8d1b34cbe13$var$shouldLog && console.log(...args);
    },
    error: (...args)=>{
        $f272c8d1b34cbe13$var$shouldLog && console.error(...args);
    },
    warn: (...args)=>{
        $f272c8d1b34cbe13$var$shouldLog && console.warn(...args);
    }
};


(0, $80a69c009606e43c$export$682e9ed90a89bb4a).define();
const $7c28c7c44e834e48$var$SCAN_RATE_LIMIT = 1000;
const $7c28c7c44e834e48$var$styles = /* css */ `
  :host {
    --scan-frame-color: rgba(255 255 255 / 0.75);
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  button {
    color: var(--text-main);
    font-family: inherit;
    font-size: inherit;
    padding: 0.625rem;
    border: none;
    border-radius: var(--border-radius);
    outline-color: var(--accent);
  }

  button:not(:disabled) {
    cursor: pointer;
  }

  button,
  select {
    outline-color: var(--accent);
  }

  .camera-select {
    padding-block: 0.75rem;
    padding-inline: 0.75rem 2.25rem;
    border: 1px solid var(--border);
    border-radius: var(--border-radius);
    background: var(--background-input) var(--select-arrow) calc(100% - 0.75rem) 50% / 0.75rem no-repeat;
    color: var(--form-text);
    font-family: inherit;
    font-size: inherit;
    cursor: pointer;
    -webkit-appearance: none;
    appearance: none;
  }

  :dir(rtl) .camera-select {
    background-position: calc(0.75rem) 50%;
  }

  .camera-select:disabled {
    cursor: not-allowed;
  }

  .scanner-container {
    position: relative;
    max-width: var(--container-max-width);
    margin: 0 auto;
  }

  .scanner-container:has(video-capture[loading]) .scan-frame {
    display: none;
  }

  .scanner-container:has(video-capture[loading]) .loading-spinner {
    display: block;
  }

  .scan-frame {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0.95);
    pointer-events: none;
  }

  .scan-frame__svg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
  }

  .scan-frame__line {
    animation: animated-scan-frame-line 2s linear infinite alternate;
  }

  @keyframes animated-scan-frame-line {
    from { transform: translateY(0); }
    to   { transform: translateY(200px); }
  }

  @media (prefers-reduced-motion: reduce) {
    .scan-frame__line {
      animation: none;
      display: none;
    }
  }

  .loading-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
  }

  video-capture {
    position: relative;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    overflow: hidden;
    border: var(--capture-border-width) solid var(--border);
    border-radius: var(--border-radius);
    background-color: #000000;
  }

  video-capture[loading]::part(video) {
    aspect-ratio: 16/9;
  }

  video-capture::part(video) {
    width: 100%;
    background-color: #000000;
  }

  video-capture [slot='actions'] {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    gap: 0.375rem;
    padding: 0.375rem;
  }

  video-capture[loading] [slot='actions'] {
    display: none;
  }

  .camera-select {
    width: 100%;
    padding-block: 0.5rem;
    border-radius: calc(var(--border-radius) / 2);
    background-color: var(--camera-actions-background);
    text-overflow: ellipsis;
    white-space: nowrap;
    text-transform: capitalize;
  }

  .zoom-controls {
    display: flex;
  }

  .torch-button,
  .zoom-controls button,
  .zoom-controls label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding-block: 0.5rem;
    border: none;
    border-radius: 0;
    background-color: var(--camera-actions-background);
    backdrop-filter: blur(2px);
    backdrop-filter: blur(2px);
    color: var(--text-main);
  }

  .torch-button {
    border: 1px solid var(--border);
    border-radius: calc(var(--border-radius) / 2);
  }

  .zoom-controls button {
    border: 1px solid var(--border);
  }

  .zoom-controls button[data-action='zoom-in'] {
    border-start-end-radius: calc(var(--border-radius) / 2);
    border-end-end-radius: calc(var(--border-radius) / 2);
    border-inline-start: none;
  }

  .zoom-controls button[data-action='zoom-out'] {
    border-start-start-radius: calc(var(--border-radius) / 2);
    border-end-start-radius: calc(var(--border-radius) / 2);
    border-inline-end: none;
  }

  .zoom-controls label {
    min-width: 2rem;
    border-block: 1px solid var(--border);
    border-inline: none;
    overflow: hidden;
    font-size: 0.9rem;
  }

  .play-video-button {
    position: absolute;
    inset: var(--capture-border-width);
    z-index: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    text-align: center;
    background-color: rgba(0, 0, 0, 0.7);
    color: #ffffff;
  }

  .play-video-button svg {
    font-size: 3.5rem;
  }

  @media (min-width: 37.5rem) {
    video-capture {
      max-width: var(--container-max-width);
    }
  }
`;
const $7c28c7c44e834e48$var$template = document.createElement('template');
$7c28c7c44e834e48$var$template.innerHTML = /* html */ `
  <style>${$7c28c7c44e834e48$var$styles}</style>

  <div class="scanner-container">
    <resize-observer>
      <video-capture auto-play id="video-capture">
        <div slot="actions">
          <button type="button" class="torch-button" id="torchButton" aria-label="Turn on flash" hidden>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="1.25em" height="1.25em" aria-hidden="true">
              <path d="M315.27 33L96 304h128l-31.51 173.23a2.36 2.36 0 002.33 2.77h0a2.36 2.36 0 001.89-.95L416 208H288l31.66-173.25a2.45 2.45 0 00-2.44-2.75h0a2.42 2.42 0 00-1.95 1z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/>
              <!-- torch disabled -->
              <path d="M432 448a15.92 15.92 0 01-11.31-4.69l-352-352a16 16 0 0122.62-22.62l352 352A16 16 0 01432 448zM294.34 84.28l-22.08 120.84a16 16 0 006.17 15.71 16.49 16.49 0 009.93 3.17h94.12l-38.37 47.42a4 4 0 00.28 5.34l17.07 17.07a4 4 0 005.94-.31l60.8-75.16a16.37 16.37 0 003.3-14.36 16 16 0 00-15.5-12H307.19L335.4 37.63c.05-.3.1-.59.13-.89A18.45 18.45 0 00302.73 23l-92.58 114.46a4 4 0 00.28 5.35l17.07 17.06a4 4 0 005.94-.31zM217.78 427.57l22-120.71a16 16 0 00-6.19-15.7 16.54 16.54 0 00-9.92-3.16h-94.1l38.36-47.42a4 4 0 00-.28-5.34l-17.07-17.07a4 4 0 00-5.93.31L83.8 293.64A16.37 16.37 0 0080.5 308 16 16 0 0096 320h108.83l-28.09 154.36v.11a18.37 18.37 0 0032.5 14.53l92.61-114.46a4 4 0 00-.28-5.35l-17.07-17.06a4 4 0 00-5.94.31z" fill="currentColor" style="display: none;"/>
              <!-- torch enabled -->
            </svg>
          </button>

          <select id="cameraSelect" class="camera-select" aria-label="Select camera" hidden>
            <option value="" disabled selected>--Select Camera--</option>
          </select>

          <div class="zoom-controls" id="zoomControls" hidden>
            <button type="button" aria-label="Zoom out" data-action="zoom-out">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                <path fill-rule="evenodd" d="M3 6.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5z"/>
              </svg>
            </button>

            <label id="zoomLevel"></label>

            <button type="button" aria-label="Zoom in" data-action="zoom-in">
              <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                <path d="M10.344 11.742c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1 6.538 6.538 0 0 1-1.398 1.4z"/>
                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5z"/>
              </svg>
            </button>
          </div>
        </div>
      </video-capture>
    </resize-observer>

    <div class="loading-spinner">
      <svg version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="50px" height="50px" viewBox="0 0 40 40" enable-background="new 0 0 40 40" xml:space="preserve">
        <path opacity="0.2" fill="white" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z"/>
        <path fill="white" d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
          <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 20 20" to="360 20 20" dur="0.5s" repeatCount="indefinite"/>
        </path>
      </svg>
    </div>

    <button id="playVideoButton" class="play-video-button" aria-label="Start camera preview" hidden>
      <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
        <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445"/>
      </svg>
    </button>

    <div id="scanFrame" class="scan-frame" hidden>
      <svg class="scan-frame__svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" aria-hidden="true">
        <path
          d="M368 448h40a40 40 0 0 0 40-40v-40 M448 144v-40a40 40 0 0 0-40-40h-40 M144 448h-40a40 40 0 0 1-40-40v-40 M64 144v-40a40 40 0 0 1 40-40h40"
          fill="none"
          stroke="var(--scan-frame-color)"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="8"
        />
        <line
          class="scan-frame__line"
          x1="120"
          y1="156"
          x2="392"
          y2="156"
          stroke="var(--scan-frame-color)"
          stroke-linecap="round"
          stroke-width="6"
        />
      </svg>
    </div>
  </div>
`;
class $7c28c7c44e834e48$export$d74867e90f5dd357 extends HTMLElement {
    #videoCaptureEl = null;
    #playVideoButtonEl = null;
    #torchButtonEl = null;
    #scanFrameEl = null;
    #cameraSelectEl = null;
    #videoCaptureVideoEl = null;
    #barcodeReader = null;
    #scanTimeoutId = null;
    #shouldScan = true;
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($7c28c7c44e834e48$var$template.content.cloneNode(true));
        }
    }
    get barcodeReader() {
        return this.#barcodeReader;
    }
    set barcodeReader(reader) {
        this.#barcodeReader = reader;
    }
    connectedCallback() {
        this.#upgradeProperty('barcodeReader');
        this.#videoCaptureEl = this.shadowRoot?.getElementById('video-capture');
        this.#playVideoButtonEl = this.shadowRoot?.getElementById('playVideoButton');
        this.#torchButtonEl = this.shadowRoot?.getElementById('torchButton');
        this.resizeObserverEl = this.shadowRoot?.querySelector('resize-observer');
        this.#scanFrameEl = this.shadowRoot?.getElementById('scanFrame');
        this.#cameraSelectEl = this.shadowRoot?.getElementById('cameraSelect');
        this.#videoCaptureVideoEl = this.#videoCaptureEl.shadowRoot?.querySelector('video');
        this.addEventListener('camera-scanner-visibility-change', this.#handleCameraScannerVisibilityChange);
        this.#playVideoButtonEl.addEventListener('click', this.#handlePlayVideo);
        this.resizeObserverEl.addEventListener('resize-observer:resize', this.#handleVideoCaptureResize);
        this.#videoCaptureEl.addEventListener('video-capture-play', this.#handleVideoCapturePlay, {
            once: true
        });
        this.#videoCaptureEl.addEventListener('video-capture-error', this.#handleVideoCaptureError, {
            once: true
        });
    }
    disconnectedCallback() {
        this.removeEventListener('camera-scanner-visibility-change', this.#handleCameraScannerVisibilityChange);
        this.#playVideoButtonEl.removeEventListener('click', this.#handlePlayVideo);
        this.resizeObserverEl.removeEventListener('resize-observer:resize', this.#handleVideoCaptureResize);
        this.#videoCaptureEl.removeEventListener('video-capture-play', this.#handleVideoCapturePlay, {
            once: true
        });
        this.#videoCaptureEl.removeEventListener('video-capture-error', this.#handleVideoCaptureError, {
            once: true
        });
    }
    /**
   * Starts the scanning process by setting the shouldScan flag to true and calling
   * the scan function if it's not already scanning. This function is used to
   * resume scanning after it has been stopped.
   */ #startScanning() {
        this.#shouldScan = true;
        if (this.#scanTimeoutId === null) this.#scan();
    }
    /**
   * Stops the scanning process by setting the shouldScan flag to false and clearing
   * any pending scan timeouts. This function is used to pause scanning when the
   * user navigates away from the camera tab or when a barcode is detected and
   * the user has chosen not to continue scanning.
   */ #stopScanning() {
        this.#shouldScan = false;
        if (this.#scanTimeoutId !== null) {
            clearTimeout(this.#scanTimeoutId);
            this.#scanTimeoutId = null;
        }
    }
    /**
   * Scans for barcodes.
   * If a barcode is detected, it stops scanning and displays the result.
   *
   * @returns {Promise<void>} A Promise that resolves when the barcode is detected.
   */ async #scan() {
        if (!this.#shouldScan || this.barcodeReader == null) return;
        (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).info('Scanning...');
        try {
            // const [, settings] = await getSettings();
            const barcode = await this.barcodeReader.detect(this.#videoCaptureVideoEl);
            const barcodeValue = barcode?.rawValue ?? '';
            if (!barcodeValue) throw new Error('No barcode detected');
            this.#emitEvent('barcode-detect-success', {
                barcodeValue: barcodeValue,
                source: 'camera-scanner'
            });
        } catch  {
        // If no barcode is detected, the error is caught here.
        // We can ignore the error and continue scanning.
        }
        if (this.#shouldScan) this.#scanTimeoutId = setTimeout(()=>{
            this.#scanTimeoutId = null;
            this.#scan();
        }, $7c28c7c44e834e48$var$SCAN_RATE_LIMIT);
    }
    /**
   * Handles the resize event on the video-capture element.
   * It is responsible for resizing the scan frame based on the video element.
   */ #handleVideoCaptureResize = ()=>{
        $7c28c7c44e834e48$var$resizeScanFrame(this.#videoCaptureEl.shadowRoot.querySelector('video'), this.#scanFrameEl);
    };
    /**
   * Handles the video play event on the video-capture element.
   * It is responsible for displaying the scan frame and starting the scan process.
   * It also handles the zoom controls if the browser supports it.
   *
   * @param {CustomEvent} evt - The event object.
   */ #handleVideoCapturePlay = async (evt)=>{
        this.#playVideoButtonEl.setAttribute('hidden', '');
        this.#scanFrameEl.removeAttribute('hidden');
        $7c28c7c44e834e48$var$resizeScanFrame(evt.detail.video, this.#scanFrameEl);
        this.#startScanning();
        const trackSettings = evt.target.getTrackSettings();
        const trackCapabilities = evt.target.getTrackCapabilities();
        const zoomLevelEl = this.shadowRoot.getElementById('zoomLevel');
        // Torch CTA
        if (trackCapabilities?.torch) {
            this.#torchButtonEl.addEventListener('click', this.#handleTorchButtonClick);
            this.#torchButtonEl.removeAttribute('hidden');
            if (this.#videoCaptureEl.hasAttribute('torch')) (0, $1352c50fc3b67223$export$d1bd0b12fe0d046)({
                el: this.#torchButtonEl,
                isTorchOn: true
            });
        }
        // Zoom controls
        if (trackSettings?.zoom && trackCapabilities?.zoom) {
            const zoomControls = this.shadowRoot?.getElementById('zoomControls');
            const minZoom = trackCapabilities?.zoom?.min || 0;
            const maxZoom = trackCapabilities?.zoom?.max || 10;
            let currentZoom = trackSettings?.zoom || 1;
            const handleZoomControlsClick = (evt)=>{
                const zoomInButtonEl = evt.target.closest('[data-action="zoom-in"]');
                const zoomOutButtonEl = evt.target.closest('[data-action="zoom-out"]');
                if (zoomInButtonEl && currentZoom < maxZoom) currentZoom += 0.5;
                if (zoomOutButtonEl && currentZoom > minZoom) currentZoom -= 0.5;
                zoomLevelEl.textContent = currentZoom.toFixed(1);
                this.#videoCaptureEl.zoom = currentZoom;
            };
            zoomControls.addEventListener('click', handleZoomControlsClick);
            zoomControls.removeAttribute('hidden');
            zoomLevelEl.textContent = currentZoom.toFixed(1);
        }
        // Camera select
        const videoInputDevices = await (0, $80a69c009606e43c$export$682e9ed90a89bb4a).getVideoInputDevices();
        videoInputDevices.forEach((device, index)=>{
            const option = this.ownerDocument.createElement('option');
            option.value = device.deviceId;
            option.textContent = device.label || `Camera ${index + 1}`;
            this.#cameraSelectEl.appendChild(option);
        });
        if (videoInputDevices.length > 1) {
            this.#cameraSelectEl.addEventListener('change', this.#handleCameraSelectChange);
            this.#cameraSelectEl.removeAttribute('hidden');
        }
    };
    /**
   * Handles the error event on the video-capture element.
   * It is responsible for displaying an error message if the camera cannot be accessed or permission is denied.
   *
   * @param {CustomEvent} evt - The event object.
   */ #handleVideoCaptureError = (evt)=>{
        const { source: source, reason: reason, error: error } = evt.detail;
        if (source === 'playback' && reason === 'user-gesture-required') {
            this.#playVideoButtonEl.removeAttribute('hidden');
            return;
        }
        let errorMessage = '<strong>Unable to start camera</strong><br>An unexpected error occurred while starting the video stream.';
        if (error.name === 'NotFoundError') errorMessage = '<strong>No camera found</strong><br>No compatible camera is available.';
        else if (source === 'camera' && reason === 'camera-access-denied') errorMessage = '<strong>Error accessing camera</strong><br>Permission to use the camera was denied. Please enable camera access in your browser settings.';
        (0, $1531977e7a058bbb$export$cbcbdc571577a620)(errorMessage, {
            duration: Infinity,
            variant: 'danger',
            announce: 'alert',
            trustDangerousInnerHTML: true
        });
    };
    /**
   * Handles the click event on the torch button.
   * It is responsible for toggling the torch on and off.
   *
   * @param {MouseEvent} evt - The event object.
   */ #handleTorchButtonClick = (evt)=>{
        this.#videoCaptureEl.torch = !this.#videoCaptureEl.torch;
        (0, $1352c50fc3b67223$export$d1bd0b12fe0d046)({
            el: evt.currentTarget,
            isTorchOn: this.#videoCaptureEl.hasAttribute('torch')
        });
    };
    /**
   * Handles the change event on the camera select element.
   * It is responsible for restarting the video stream with the selected video input device id.
   *
   * @param {Event} evt - The event object.
   */ #handleCameraSelectChange = (evt)=>{
        const videoDeviceId = evt.target.value || undefined;
        this.#videoCaptureEl.restartVideoStream?.(videoDeviceId);
    };
    /**
   * Handles video play button click event.
   */ #handlePlayVideo = ()=>{
        if (!this.#videoCaptureEl) return;
        if (this.#videoCaptureEl.loading) return;
        this.#videoCaptureEl.playVideo?.({
            emit: true
        });
        this.#playVideoButtonEl.setAttribute('hidden', '');
    };
    /**
   * Handles the camera scanner visibility change event.
   *
   * @param {CustomEvent} evt - The event object.
   */ #handleCameraScannerVisibilityChange = async (evt)=>{
        const { visibility: visibility } = evt.detail;
        if (visibility === 'visible') {
            const videoDeviceId = this.#cameraSelectEl.value || undefined;
            const started = await this.#videoCaptureEl.startVideoStream?.(videoDeviceId);
            if (started) this.#startScanning();
        } else {
            this.#stopScanning();
            this.#videoCaptureEl.stopVideoStream?.();
        }
    };
    /**
   * Dispatches a custom event with the given name.
   *
   * @param {string} eventName - The name of the event to dispatch.
   * @param {any} detail - The detail object to include with the event.
   */ #emitEvent(eventName, detail = null) {
        const options = {
            bubbles: true,
            composed: true,
            detail: detail
        };
        const evt = new CustomEvent(eventName, options);
        this.dispatchEvent(evt);
    }
    /**
   * Re-applies a property value that may have been set on the element
   * instance before the custom element was defined.
   *
   * This handles cases where a framework sets a property on the element
   * before its definition is loaded. Without this step, the own property
   * on the instance would shadow the class setter and prevent it from
   * running after upgrade.
   *
   * @see https://web.dev/articles/custom-elements-best-practices#make_properties_lazy
   *
   * @param {string} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='camera-scanner'] - The tag name to use for the custom element.
   */ static define(tagName = 'camera-scanner') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $7c28c7c44e834e48$export$d74867e90f5dd357);
    }
}
/**
 * Resizes the scan frame to match the video element's dimensions.
 *
 * @param {HTMLVideoElement} videoEl - The video element.
 * @param {HTMLElement} scanFrameEl - The scan frame element.
 */ function $7c28c7c44e834e48$var$resizeScanFrame(videoEl, scanFrameEl) {
    if (!videoEl || !scanFrameEl) return;
    const rect = videoEl.getBoundingClientRect();
    scanFrameEl.style.cssText = `width: ${rect.width}px; height: ${rect.height}px`;
}


const $c36678a5ac519ae6$var$ACCEPTED_MIME_TYPES = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/apng',
    'image/gif',
    'image/webp',
    'image/avif'
];
const $c36678a5ac519ae6$var$styles = /* css */ `
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  .dropzone {
    --dropzone-focus-box-shadow: inset 0 0 0 2px var(--focus);
    --dropzone-transition-duration: var(--animation-duration);
    --dropzone-border-color: var(--border);
    --dropzone-border-color-dragover: var(--accent);
    --dropzone-border-color-hover: var(--accent);
    --dropzone-background-color: var(--dropzone-background);
    --dropzone-background-color-dragover: var(--dropzone-background-dragover);
    --dropzone-background-color-hover: var(--dropzone-background-hover);
    --dropzone-body-color: var(--text-main);
  }

  .dropzone::part(dropzone) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0 auto;
    min-height: 17.625rem;
    border-radius: var(--border-radius);
  }

  .dropzone-preview {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .dropzone-preview__image-wrapper {
    max-width: 200px;
    margin: 0 auto;
  }

  .dropzone-preview__image-wrapper img {
    max-width: 100%;
    height: auto;
  }

  .dropzone-preview__file-name {
    font-size: 0.9rem;
    color: var(--text-main);
  }

  .dropzone-instructions {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 0.75rem;
  }
`;
const $c36678a5ac519ae6$var$template = document.createElement('template');
$c36678a5ac519ae6$var$template.innerHTML = /* html */ `
  <style>${$c36678a5ac519ae6$var$styles}</style>

  <files-dropzone id="dropzone" class="dropzone">
    <span class="dropzone-instructions">
      <svg width="3.125em" height="3.125em" viewBox="0 0 21 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" aria-hidden="true">
        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g transform="translate(-850.000000, -2681.000000)">
            <g transform="translate(100.000000, 2626.000000)">
              <g transform="translate(748.000000, 54.000000)">
                <g>
                  <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                  <path d="M10.21,16.83 L12.96,13.29 L16.5,18 L5.5,18 L8.25,14.47 L10.21,16.83 Z M20,4 L23,4 L23,6 L20,6 L20,8.99 L18,8.99 L18,6 L15,6 L15,4 L18,4 L18,1 L20,1 L20,4 Z M18,20 L18,10 L20,10 L20,20 C20,21.1 19.1,22 18,22 L4,22 C2.9,22 2,21.1 2,20 L2,6 C2,4.9 2.9,4 4,4 L14,4 L14,6 L4,6 L4,20 L18,20 Z" fill="currentColor"></path>
                  <path d="M16.5,18 L5.5,18 L8.25,14.47 L10.21,16.83 L12.96,13.29 L16.5,18 Z M17,7 L14,7 L14,6 L4,6 L4,20 L18,20 L18,10 L17,10 L17,7 Z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>

      Click or drop an image to scan
    </span>
  </files-dropzone>
`;
class $c36678a5ac519ae6$export$ef58f9e9dd099da4 extends HTMLElement {
    #dropzoneEl = null;
    #barcodeReader = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($c36678a5ac519ae6$var$template.content.cloneNode(true));
        }
    }
    get barcodeReader() {
        return this.#barcodeReader;
    }
    set barcodeReader(reader) {
        this.#barcodeReader = reader;
    }
    connectedCallback() {
        this.#upgradeProperty('barcodeReader');
        this.#dropzoneEl = this.shadowRoot?.getElementById('dropzone');
        this.#dropzoneEl.accept = $c36678a5ac519ae6$var$ACCEPTED_MIME_TYPES.join(',');
        this.#dropzoneEl.addEventListener('files-dropzone-drop', this.#handleFileDrop);
    }
    disconnectedCallback() {
        this.#dropzoneEl.removeEventListener('files-dropzone-drop', this.#handleFileDrop);
    }
    /**
   * Handles the selection of a file.
   * It is responsible for displaying the selected file in the dropzone.
   *
   * @param {File} file - The selected file.
   */ #handleFileSelect = async (file)=>{
        if (!file) return;
        const image = new Image();
        const reader = new FileReader();
        reader.onload = (evt)=>{
            const data = evt.target.result;
            image.onload = async ()=>{
                try {
                    const barcode = await this.barcodeReader.detect(image);
                    const barcodeValue = barcode?.rawValue ?? '';
                    if (!barcodeValue) throw new Error('No barcode detected');
                    this.#emitEvent('barcode-detect-success', {
                        barcodeValue: barcodeValue,
                        source: 'file-scanner'
                    });
                } catch (error) {
                    this.#emitEvent('barcode-detect-error', {
                        error: error,
                        source: 'file-scanner'
                    });
                }
            };
            image.src = data;
            image.alt = 'Image preview';
            this.#dropzoneEl.replaceChildren();
            const preview = document.createElement('div');
            preview.className = 'dropzone-preview';
            const imageWrapper = document.createElement('div');
            imageWrapper.className = 'dropzone-preview__image-wrapper';
            const fileNameWrapper = document.createElement('div');
            fileNameWrapper.className = 'dropzone-preview__file-name';
            fileNameWrapper.textContent = file.name;
            imageWrapper.appendChild(image);
            preview.appendChild(imageWrapper);
            preview.appendChild(fileNameWrapper);
            this.#dropzoneEl.prepend(preview);
        };
        reader.readAsDataURL(file);
    };
    /**
   * Handles the drop event on the dropzone.
   *
   * @param {CustomEvent} evt - The event object.
   */ #handleFileDrop = (evt)=>{
        const file = evt.detail.acceptedFiles[0];
        this.#handleFileSelect(file);
    };
    /**
   * Dispatches a custom event with the given name.
   *
   * @param {string} eventName - The name of the event to dispatch.
   * @param {any} detail - The detail object to include with the event.
   */ #emitEvent(eventName, detail = null) {
        const options = {
            bubbles: true,
            composed: true,
            detail: detail
        };
        const evt = new CustomEvent(eventName, options);
        this.dispatchEvent(evt);
    }
    /**
   * Re-applies a property value that may have been set on the element
   * instance before the custom element was defined.
   *
   * This handles cases where a framework sets a property on the element
   * before its definition is loaded. Without this step, the own property
   * on the instance would shadow the class setter and prevent it from
   * running after upgrade.
   *
   * @see https://web.dev/articles/custom-elements-best-practices#make_properties_lazy
   *
   * @param {string} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='file-scanner'] - The tag name to use for the custom element.
   */ static define(tagName = 'file-scanner') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $c36678a5ac519ae6$export$ef58f9e9dd099da4);
    }
}


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $7a2aca835bb05064$export$c37129e465f64ef0(a) {
    return a !== null && typeof a == "object" ? "share" in navigator && "canShare" in navigator && navigator.canShare(a) : "share" in navigator;
}


const $c838dd7e93d6a54a$export$59113f23fb667b84 = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
});


function $dc2f4a51b83babfd$var$_slicedToArray(r, e) {
    return $dc2f4a51b83babfd$var$_arrayWithHoles(r) || $dc2f4a51b83babfd$var$_iterableToArrayLimit(r, e) || $dc2f4a51b83babfd$var$_unsupportedIterableToArray(r, e) || $dc2f4a51b83babfd$var$_nonIterableRest();
}
function $dc2f4a51b83babfd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc2f4a51b83babfd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dc2f4a51b83babfd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dc2f4a51b83babfd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $dc2f4a51b83babfd$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $dc2f4a51b83babfd$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function getDB() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $dc2f4a51b83babfd$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $dc2f4a51b83babfd$var$defaultGetStoreFunc;
function $dc2f4a51b83babfd$var$defaultGetStore() {
    if (!$dc2f4a51b83babfd$var$defaultGetStoreFunc) $dc2f4a51b83babfd$var$defaultGetStoreFunc = $dc2f4a51b83babfd$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $dc2f4a51b83babfd$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($dc2f4a51b83babfd$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
function $dc2f4a51b83babfd$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys()),
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $dc2f4a51b83babfd$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


const $2a0cdf86b860bd9c$export$f92dfeb71e9bb569 = async (key)=>{
    try {
        return [
            null,
            await (0, $dc2f4a51b83babfd$export$3988ae62b71be9a3)(key)
        ];
    } catch (error) {
        return [
            error,
            void 0
        ];
    }
};
const $2a0cdf86b860bd9c$export$8a8216c44337cd5 = async (key, data)=>{
    try {
        await (0, $dc2f4a51b83babfd$export$adaa4cf7ef1b65be)(key, data);
        return [
            null
        ];
    } catch (error) {
        return [
            error
        ];
    }
};


const $446905cc56717322$var$SETTINGS_KEY = 'barcode-scanner/settings';
const $446905cc56717322$export$4a647155031ece = async ()=>{
    return (0, $2a0cdf86b860bd9c$export$f92dfeb71e9bb569)($446905cc56717322$var$SETTINGS_KEY);
};
const $446905cc56717322$export$dc86d17a64679bc7 = async (data)=>{
    return (0, $2a0cdf86b860bd9c$export$8a8216c44337cd5)($446905cc56717322$var$SETTINGS_KEY, data);
};


const $8e270c8ee0fa00f4$var$styles = /* css */ `
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  .result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    position: relative;
    width: 100%;
    padding: 0.5rem;
  }

  .result__item {
    word-wrap: break-word;
    word-break: break-word;
    white-space: pre-line;
  }

  a.result__item {
    color: var(--links);
  }

  .result__datetime {
    font-size: 0.8rem;
    color: var(--text-muted);
    margin-block-start: 0.25rem;
  }

  .result__datetime:empty {
    display: none !important;
  }

  .result__actions {
    display: flex;
    align-items: center;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
  }

  .result web-share button,
  .result clipboard-copy::part(button) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem;
    background-color: transparent;
    border: 0;
    border-radius: var(--border-radius);
    color: inherit;
    line-height: 1;
    font-family: inherit;
    font-size: 0.9rem;
    cursor: pointer;
  }

  .result clipboard-copy::part(button--success) {
    color: var(--success-color);
  }

  .result clipboard-copy::part(button--error) {
    color: var(--danger-color);
  }
`;
const $8e270c8ee0fa00f4$var$template = document.createElement('template');
$8e270c8ee0fa00f4$var$template.innerHTML = /* html */ `
  <style>${$8e270c8ee0fa00f4$var$styles}</style>

  <div class="result" part="result">
    <div class="result__content">
      <div class="result__datetime"></div>
    </div>

    <div class="result__actions">
      <clipboard-copy only-icon></clipboard-copy>

      <web-share>
        <button slot="button" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>
          </svg>
        </button>
      </web-share>
    </div>
  </div>
`;
class $8e270c8ee0fa00f4$export$cf8fda1f33c080ab extends HTMLElement {
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($8e270c8ee0fa00f4$var$template.content.cloneNode(true));
        }
    }
    get value() {
        return this.getAttribute('value');
    }
    set value(value) {
        this.setAttribute('value', value);
    }
    static get observedAttributes() {
        return [
            'value'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'value' && oldValue !== newValue) this.#handleValueChange(this.value);
    }
    connectedCallback() {
        this.#upgradeProperty('value');
        this.#highlight();
        if (!(0, $7a2aca835bb05064$export$c37129e465f64ef0)()) {
            const webShareEl = this.shadowRoot.querySelector('web-share');
            if (webShareEl) webShareEl.hidden = true;
        }
    }
    /**
   * Handles changes to the `value` attribute by creating a new result element
   * with the updated value, updating the datetime, and configuring the copy
   * and share buttons.
   *
   * @param {string} value - The new value to display in the result.
   */ async #handleValueChange(value) {
        const baseEl = this.shadowRoot.querySelector('.result');
        const resultContentEl = baseEl?.querySelector('.result__content');
        const resultDatetimeEl = baseEl?.querySelector('.result__datetime');
        const oldResultEl = baseEl?.querySelector('.result__item');
        let resultEl;
        if (oldResultEl) oldResultEl?.remove();
        try {
            const [, settings] = await (0, $446905cc56717322$export$4a647155031ece)();
            new URL(value);
            resultEl = document.createElement('a');
            resultEl.href = value;
            if (!settings?.openWebPageSameTab) {
                resultEl.setAttribute('target', '_blank');
                resultEl.setAttribute('rel', 'noreferrer noopener');
            }
            if (settings?.openWebPage) resultEl.click();
            else window.requestAnimationFrame(()=>resultEl.focus());
        } catch  {
            resultEl = document.createElement('span');
        }
        resultEl.className = 'result__item';
        resultEl.part = 'result__item';
        resultEl.textContent = value;
        resultDatetimeEl.textContent = (0, $c838dd7e93d6a54a$export$59113f23fb667b84).format(new Date());
        resultContentEl?.insertBefore(resultEl, resultDatetimeEl);
        const copyEl = baseEl?.querySelector('clipboard-copy');
        const shareEl = baseEl?.querySelector('web-share');
        if (copyEl) {
            const copyButtonEl = copyEl.shadowRoot?.querySelector('button');
            copyEl.setAttribute('value', value);
            copyButtonEl?.setAttribute('aria-label', 'Copy scan result to clipboard');
            copyEl.hidden = false;
        }
        if (shareEl && (0, $7a2aca835bb05064$export$c37129e465f64ef0)()) {
            const shareButtonEl = shareEl.querySelector('button');
            shareEl.setAttribute('share-text', value);
            shareEl.hidden = false;
            shareButtonEl?.setAttribute('aria-label', 'Share scan result');
        }
    }
    /**
   * Animates the background color of the result element to highlight it when it
   * first appears.
   */ #highlight() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        const baseEl = this.shadowRoot.querySelector('.result');
        const from = {
            backgroundColor: 'var(--highlight)'
        };
        const to = {
            backgroundColor: 'transparent'
        };
        const opts = {
            duration: 400,
            easing: 'ease-out'
        };
        baseEl?.animate([
            from,
            to
        ], opts);
    }
    /**
   * Re-applies a property value that may have been set on the element
   * instance before the custom element was defined.
   *
   * This handles cases where a framework sets a property on the element
   * before its definition is loaded. Without this step, the own property
   * on the instance would shadow the class setter and prevent it from
   * running after upgrade.
   *
   * @see https://web.dev/articles/custom-elements-best-practices#make_properties_lazy
   *
   * @param {string} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='scan-result'] - The tag name to use for the custom element.
   */ static define(tagName = 'scan-result') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $8e270c8ee0fa00f4$export$cf8fda1f33c080ab);
    }
}



class $09c97d2bbff7c615$export$c2d904671643938c extends HTMLElement {
    #formatsWrapperEl = null;
    #formatItemTemplateEl = null;
    #formEl = null;
    #supportedFormats = [];
    #settings;
    constructor(){
        super();
    }
    get supportedFormats() {
        return this.#supportedFormats;
    }
    set supportedFormats(value) {
        this.#supportedFormats = value;
        this.#renderFormats();
    }
    async connectedCallback() {
        this.#upgradeProperty('supportedFormats');
        this.#formatsWrapperEl = this.querySelector('#formatsList');
        this.#formatItemTemplateEl = this.querySelector('#formatItemTemplate');
        this.#formEl = this.querySelector('form');
        const [, settings] = await (0, $446905cc56717322$export$4a647155031ece)();
        this.#settings = settings ?? {};
        this.#formEl?.querySelectorAll(`[name="general-settings"]`).forEach((input)=>{
            input.checked = this.#settings[input.value];
        });
    }
    /**
   * Renders the list of supported formats as checkboxes in the settings form.
   *
   * This method clears any existing format checkboxes and creates new ones
   * based on the `supportedFormats` property. It also checks the boxes based
   * on the formats stored in the settings, defaulting to checked if no
   * settings are found.
   */ #renderFormats() {
        if (!this.#formatsWrapperEl || !this.#formatItemTemplateEl) return;
        const formatsFromStorage = this.#settings?.formats;
        const fragment = this.ownerDocument.createDocumentFragment();
        this.supportedFormats.forEach((format)=>{
            const itemEl = this.#formatItemTemplateEl.content.firstElementChild.cloneNode(true);
            const inputEl = itemEl.querySelector('input');
            inputEl.value = format;
            inputEl.checked = formatsFromStorage != null ? formatsFromStorage.includes(format) : true;
            const labelTextEl = itemEl.querySelector('[data-format-label]');
            labelTextEl.textContent = format;
            fragment.appendChild(itemEl);
        });
        this.#formatsWrapperEl.replaceChildren(fragment);
    }
    /**
   * Re-applies a property value that may have been set on the element
   * instance before the custom element was defined.
   *
   * This handles cases where a framework sets a property on the element
   * before its definition is loaded. Without this step, the own property
   * on the instance would shadow the class setter and prevent it from
   * running after upgrade.
   *
   * @see https://web.dev/articles/custom-elements-best-practices#make_properties_lazy
   *
   * @param {string} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='scan-settings'] - The tag name to use for the custom element.
   */ static define(tagName = 'scan-settings') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $09c97d2bbff7c615$export$c2d904671643938c);
    }
}




const $d775cf11dfb39586$var$HISTORY_KEY = 'barcode-scanner/history';
const $d775cf11dfb39586$export$f9582a3c130d9538 = async ()=>{
    return (0, $2a0cdf86b860bd9c$export$f92dfeb71e9bb569)($d775cf11dfb39586$var$HISTORY_KEY);
};
const $d775cf11dfb39586$export$96fe1132eb44c325 = async (data)=>{
    return (0, $2a0cdf86b860bd9c$export$8a8216c44337cd5)($d775cf11dfb39586$var$HISTORY_KEY, data);
};


const $989f3e0d02ea7e93$var$styles = /* css */ `
  :host {
    --empty-history-button-color: #ffffff;

    display: block;
    box-sizing: border-box;
  }

  @media (prefers-color-scheme: dark) {
    :host {
      --empty-history-button-color: #000000;
    }
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  ul {
    max-width: 36.25rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  ul li {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid var(--border);
    color: var(--text-main);
  }

  ul li:last-of-type {
    border-bottom: none;
  }

  ul li a {
    color: var(--links);
  }

  ul li a,
  ul li span {
    word-break: break-all;
  }

  @supports (-webkit-line-clamp: 1) and (display: -webkit-box) and (-webkit-box-orient: vertical) {
    ul li a,
    ul li span {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    }
  }

  .actions {
    display: flex;
    gap: 0.25rem;
  }

  .actions button,
  .actions clipboard-copy::part(button) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    margin: 0;
    border: 0;
    border-radius: var(--border-radius);
    background-color: transparent !important;
    line-height: 1;
    font-size: 1rem;
    color: var(--text-main);
    cursor: pointer;
  }

  .actions clipboard-copy::part(button--success) {
    color: var(--success-color);
  }

  .actions clipboard-copy::part(button--error) {
    color: var(--danger-color);
  }

  .actions .delete-action {
    color: var(--danger-color);
    margin-right: -0.5rem;
  }

  footer {
    position: sticky;
    bottom: 0;
    padding: 0.75rem;
    background-color: var(--dialog-background);
  }

  footer > button {
    width: 100%;
    padding: 0.625rem;
    border: 0;
    border-radius: var(--border-radius);
    background-color: var(--danger-color);
    color: var(--empty-history-button-color);
    font-size: 1rem;
    cursor: pointer;
  }

  ul:empty + footer > button {
    display: none;
  }

  ul:not(:empty) + footer > div {
    display: none;
  }
`;
const $989f3e0d02ea7e93$var$template = document.createElement('template');
$989f3e0d02ea7e93$var$template.innerHTML = /* html */ `
  <style>${$989f3e0d02ea7e93$var$styles}</style>
  <ul id="historyList"></ul>
  <footer>
    <div>There are no saved items in history.</div>
    <button type="button" id="emptyHistoryButton">Empty history</button>
  </footer>
`;
class $989f3e0d02ea7e93$export$fba881dabebd1e10 extends HTMLElement {
    #historyListEl = null;
    #emptyHistoryButtonEl = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($989f3e0d02ea7e93$var$template.content.cloneNode(true));
        }
    }
    async connectedCallback() {
        this.#historyListEl = this.shadowRoot?.getElementById('historyList');
        this.#emptyHistoryButtonEl = this.shadowRoot?.getElementById('emptyHistoryButton');
        this.#renderHistoryList((await (0, $d775cf11dfb39586$export$f9582a3c130d9538)())[1] || []);
        this.#historyListEl?.addEventListener('click', this.#handleHistoryListClick);
        this.#emptyHistoryButtonEl?.addEventListener('click', this.#handleEmptyHistoryClick);
    }
    disconnectedCallback() {
        this.#historyListEl?.removeEventListener('click', this.#handleHistoryListClick);
        this.#emptyHistoryButtonEl?.removeEventListener('click', this.#handleEmptyHistoryClick);
    }
    /**
   * Adds an item to the history.
   * If the item is already in history, it will not be added.
   *
   * @param {string} item - The item to add to history.
   * @returns {Promise<null|Error>} `null` if successful, or an error if there was an issue.
   */ async add(item) {
        if (!item) return;
        const errPayload = {
            type: 'add',
            message: 'Error adding barcode to history'
        };
        const [getHistoryError, history = []] = await (0, $d775cf11dfb39586$export$f9582a3c130d9538)();
        if (getHistoryError || !Array.isArray(history)) {
            this.#emitEvent('scan-history-error', errPayload);
            return getHistoryError;
        }
        if (history.find((h)=>h === item)) return;
        const data = [
            ...history,
            item
        ];
        const [setHistoryError] = await (0, $d775cf11dfb39586$export$96fe1132eb44c325)(data);
        if (setHistoryError) {
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).error('Error setting history', setHistoryError);
            this.#emitEvent('scan-history-error', errPayload);
            return setHistoryError;
        }
        this.#historyListEl?.insertBefore(this.#createHistoryItemElement(item), this.#historyListEl.firstElementChild);
        this.#emitEvent('scan-history-success', {
            type: 'add',
            message: 'Barcode added to history'
        });
        return null;
    }
    /**
   * Removes an item from the history.
   *
   * @param {string} item - The item to remove from history.
   * @returns {Promise<null|Error>} `null` if successful, or an error if there was an issue.
   */ async remove(item) {
        if (!item) return;
        const errPayload = {
            type: 'remove',
            message: 'Error removing barcode from history'
        };
        const [getHistoryError, history = []] = await (0, $d775cf11dfb39586$export$f9582a3c130d9538)();
        if (getHistoryError || !Array.isArray(history)) {
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).error('Error getting history before removal', getHistoryError);
            this.#emitEvent('scan-history-error', errPayload);
            return getHistoryError;
        }
        const data = history.filter((el)=>el !== item);
        const [setHistoryError] = await (0, $d775cf11dfb39586$export$96fe1132eb44c325)(data);
        if (setHistoryError) {
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).error('Error setting history after removal', setHistoryError);
            this.#emitEvent('scan-history-error', errPayload);
            return setHistoryError;
        }
        const historyItem = this.#historyListEl?.querySelector(`li[data-value="${item}"]`);
        historyItem?.remove();
        this.#emitEvent('scan-history-success', {
            type: 'remove',
            message: 'Barcode removed from history'
        });
        return null;
    }
    /**
   * Removes all items from the history.
   *
   * @returns {Promise<null|Error>} `null` if successful, or an error if there was an issue
   */ async empty() {
        const [setHistoryError] = await (0, $d775cf11dfb39586$export$96fe1132eb44c325)([]);
        if (setHistoryError) {
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).error('Error setting history', setHistoryError);
            this.#emitEvent('scan-history-error', {
                type: 'empty',
                message: 'Error emptying history'
            });
            return setHistoryError;
        }
        this.#historyListEl?.replaceChildren();
        this.#emitEvent('scan-history-success', {
            type: 'empty',
            message: 'History emptied successfully'
        });
        return null;
    }
    /**
   * Renders the history list. If there are no items in history, it will show a message.
   *
   * @param {Array<string>} data - History data as an array of strings.
   */ #renderHistoryList(data) {
        if (!this.#historyListEl) return;
        this.#historyListEl.replaceChildren();
        const fragment = document.createDocumentFragment();
        [
            ...data
        ].reverse().forEach((item)=>fragment.appendChild(this.#createHistoryItemElement(item)));
        this.#historyListEl.appendChild(fragment);
    }
    /**
   * Creates a history item element.
   * If the item is a URL, it will be an anchor element, otherwise a span element.
   *
   * @param {string} item - The history item to create an element for.
   * @returns {HTMLLIElement} The history item element.
   */ #createHistoryItemElement(item) {
        const li = document.createElement('li');
        li.setAttribute('data-value', item);
        let historyItem;
        try {
            new URL(item);
            historyItem = document.createElement('a');
            historyItem.href = item;
            historyItem.setAttribute('target', '_blank');
            historyItem.setAttribute('rel', 'noreferrer noopener');
        } catch  {
            historyItem = document.createElement('span');
        }
        historyItem.textContent = item;
        const actionsEl = document.createElement('div');
        actionsEl.className = 'actions';
        const copyEl = document.createElement('clipboard-copy');
        const copyButtonEl = copyEl.shadowRoot?.querySelector('button');
        copyEl.setAttribute('only-icon', '');
        copyEl.setAttribute('value', item);
        copyButtonEl?.setAttribute('aria-label', `Copy to clipboard ${item}`);
        actionsEl.appendChild(copyEl);
        const removeButtonEl = document.createElement('button');
        removeButtonEl.type = 'button';
        removeButtonEl.className = 'delete-action';
        removeButtonEl.setAttribute('data-action', 'delete');
        removeButtonEl.setAttribute('aria-label', `Remove from history ${item}`);
        removeButtonEl.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
      </svg>
    `;
        actionsEl.appendChild(removeButtonEl);
        li.appendChild(historyItem);
        li.appendChild(actionsEl);
        return li;
    }
    /**
   * Handles the click event on the history list.
   *
   * @param {Event} evt - The event object
   */ #handleHistoryListClick = async (evt)=>{
        const target = evt.target;
        if (target.closest('[data-action="delete"]')) {
            const value = target.closest('li').dataset.value;
            if (window.confirm(`Delete history item ${value}?`)) this.remove(value);
        }
    };
    /**
   * Handles the click event on the empty history button.
   */ #handleEmptyHistoryClick = async ()=>{
        if (window.confirm('Empty history? This action cannot be undone.')) this.empty();
    };
    /**
   * Dispatches a custom event with the given name.
   *
   * @param {string} eventName - The name of the event to dispatch.
   * @param {Nullable<any>} detail - The detail object to include with the event.
   */ #emitEvent(eventName, detail = null) {
        const options = {
            bubbles: true,
            composed: true,
            detail: detail
        };
        const evt = new CustomEvent(eventName, options);
        this.dispatchEvent(evt);
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='scan-history'] - The tag name to use for the custom element.
   */ static define(tagName = 'scan-history') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $989f3e0d02ea7e93$export$fba881dabebd1e10);
    }
}


/*!
 * @georapbox/clipboard-copy-element
 * A custom element that implements the Clipboard API to copy text content from elements or input values to the clipboard.
 *
 * @version 3.0.2
 * @homepage https://github.com/georapbox/clipboard-copy-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $449da37d108ee4fe$var$i = "clipboard-copy";
var $449da37d108ee4fe$var$o = "success", $449da37d108ee4fe$var$n = "error", $449da37d108ee4fe$var$h = document.createElement("template"), $449da37d108ee4fe$var$a = `
  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }
`;
$449da37d108ee4fe$var$h.innerHTML = `
  <style>${$449da37d108ee4fe$var$a}</style>
  <button type="button" part="button">
    <slot name="copy">Copy</slot>
    <slot name="success" hidden>Copied!</slot>
    <slot name="error" hidden>Error</slot>
  </button>
`;
var $449da37d108ee4fe$export$ea3b71af1761ff40 = class d extends HTMLElement {
    #e = void 0;
    #t = null;
    #s = null;
    #i = null;
    #o = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($449da37d108ee4fe$var$h.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.querySelector("button"), this.#s = this.shadowRoot.querySelector('slot[name="copy"]'), this.#i = this.shadowRoot.querySelector('slot[name="success"]'), this.#o = this.shadowRoot.querySelector('slot[name="error"]'));
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, s, e) {
        t === "disabled" && s !== e && this.#t && (this.#t.disabled = this.disabled, this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#n("value"), this.#n("from"), this.#n("disabled"), this.#n("feedbackDuration"), this.#t?.addEventListener("click", this.#r);
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("click", this.#r), this.#a();
    }
    get value() {
        return this.getAttribute("value") || "";
    }
    set value(t) {
        this.setAttribute("value", t != null ? t.toString() : t);
    }
    get from() {
        return this.getAttribute("from") || "";
    }
    set from(t) {
        this.setAttribute("from", t != null ? t.toString() : t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get feedbackDuration() {
        return Number(this.getAttribute("feedback-duration")) || 1e3;
    }
    set feedbackDuration(t) {
        this.setAttribute("feedback-duration", t != null ? t.toString() : t);
    }
    async #d() {
        if (!(!this.value && !this.from)) try {
            let t = "";
            if (this.value) t = this.value;
            else if (this.from) {
                let s = "getRootNode" in Element.prototype ? this.#t?.getRootNode({
                    composed: !0
                }) : this.#t?.ownerDocument;
                if (!s || !(s instanceof Document || s instanceof ShadowRoot)) return;
                let e = s.querySelector(this.from);
                if (!e) return;
                e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement ? t = e.value : e instanceof HTMLAnchorElement && e.hasAttribute("href") ? t = e.href : t = e.textContent || "";
            }
            await navigator.clipboard.writeText(t), this.#h($449da37d108ee4fe$var$o), this.dispatchEvent(new CustomEvent(`${$449da37d108ee4fe$var$i}-success`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    value: t
                }
            }));
        } catch (t) {
            this.#h($449da37d108ee4fe$var$n), this.dispatchEvent(new CustomEvent(`${$449da37d108ee4fe$var$i}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #r = (t)=>{
        t.preventDefault(), !(this.disabled || this.#e) && this.#d();
    };
    #h(t) {
        this.#s && (this.#s.hidden = !0), this.#i && (this.#i.hidden = t !== $449da37d108ee4fe$var$o), this.#o && (this.#o.hidden = t !== $449da37d108ee4fe$var$n), this.#t?.part.remove("button--success"), this.#t?.part.remove("button--error"), this.#t?.part.add(`button--${t}`), this.#e && clearTimeout(this.#e), this.#e = setTimeout(()=>{
            this.#s && (this.#s.hidden = !1), this.#i && (this.#i.hidden = !0), this.#o && (this.#o.hidden = !0), this.#t?.part.remove(`button--${t}`), this.#e = void 0;
        }, this.feedbackDuration);
    }
    #a() {
        this.#e && clearTimeout(this.#e), this.#e = void 0, this.#s && (this.#s.hidden = !1), this.#i && (this.#i.hidden = !0), this.#o && (this.#o.hidden = !0), this.#t?.part.remove("button--success"), this.#t?.part.remove("button--error");
    }
    #n(t) {
        let s = this;
        if (Object.prototype.hasOwnProperty.call(s, t)) {
            let e = s[t];
            delete s[t], s[t] = e;
        }
    }
    static defineCustomElement(t = $449da37d108ee4fe$var$i) {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, d);
    }
};


/**
 * Extends the `BaseClipboardCopy` element to override the default `copy` and `success` slots,
 * in order to avoid repetition of the same markup throughout the application.
 * It also adds aditional properties and attributes, specific to the application.
 */ class $653dbbfb5637c6d8$export$ea3b71af1761ff40 extends (0, $449da37d108ee4fe$export$ea3b71af1761ff40) {
    constructor(){
        super();
        const copySlot = this.shadowRoot.querySelector('slot[name="copy"]');
        const successSlot = this.shadowRoot.querySelector('slot[name="success"]');
        const errorSlot = this.shadowRoot.querySelector('slot[name="error"]');
        copySlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
      </svg>
      <span class="text">Copy</span>
    `;
        successSlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
      </svg>
      <span class="text">Copied!</span>
    `;
        errorSlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path fill-rule="evenodd" d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
      </svg>
      <span class="text">Error</span>
    `;
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            'only-icon'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'only-icon' && oldValue !== newValue) {
            const copySlot = this.shadowRoot.querySelector('slot[name="copy"]');
            const successSlot = this.shadowRoot.querySelector('slot[name="success"]');
            const errorSlot = this.shadowRoot.querySelector('slot[name="error"]');
            const copyText = copySlot.querySelector('.text');
            const successText = successSlot.querySelector('.text');
            const errorText = errorSlot.querySelector('.text');
            copyText?.toggleAttribute('hidden', this.onlyIcon);
            successText?.toggleAttribute('hidden', this.onlyIcon);
            errorText?.toggleAttribute('hidden', this.onlyIcon);
        }
    }
    get onlyIcon() {
        return this.hasAttribute('only-icon');
    }
    set onlyIcon(value) {
        if (value) this.setAttribute('only-icon', '');
        else this.removeAttribute('only-icon');
    }
    connectedCallback() {
        super.connectedCallback();
        this.#upgradeProperty('onlyIcon');
        if (!this.hasAttribute('feedback-duration')) this.setAttribute('feedback-duration', '1500');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    /**
   * Re-applies a property value that may have been set on the element
   * instance before the custom element was defined.
   *
   * This handles cases where a framework sets a property on the element
   * before its definition is loaded. Without this step, the own property
   * on the instance would shadow the class setter and prevent it from
   * running after upgrade.
   *
   * @see https://web.dev/articles/custom-elements-best-practices#make_properties_lazy
   *
   * @param {string} prop - The property name to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    /**
   * Defines the custom element by registering it with the browser's
   * CustomElementRegistry if it hasn't been defined already.
   *
   * @param {string} [tagName='clipboard-copy'] - The tag name to use for the custom element.
   */ static define(tagName = 'clipboard-copy') {
        if (typeof window === 'undefined' || window.customElements.get(tagName)) return;
        window.customElements.define(tagName, $653dbbfb5637c6d8$export$ea3b71af1761ff40);
    }
}


function $be80c1b207286e9d$export$e73a9d346ce244ee() {
    (0, $7c28c7c44e834e48$export$d74867e90f5dd357).define();
    (0, $c36678a5ac519ae6$export$ef58f9e9dd099da4).define();
    (0, $8e270c8ee0fa00f4$export$cf8fda1f33c080ab).define();
    (0, $09c97d2bbff7c615$export$c2d904671643938c).define();
    (0, $989f3e0d02ea7e93$export$fba881dabebd1e10).define();
    (0, $653dbbfb5637c6d8$export$ea3b71af1761ff40).define();
}



// https://developer.mozilla.org/en-US/docs/Web/API/Barcode_Detection_API#supported_barcode_formats
const $bd6a3ece56e4d687$var$WHITELISTED_FORMATS = [
    'aztec',
    'code_128',
    'code_39',
    'code_93',
    'codabar',
    'data_matrix',
    'ean_13',
    'ean_8',
    'itf',
    'pdf417',
    'qr_code',
    'upc_a',
    'upc_e'
];

/**
 * BarcodeReader class to detect barcodes from images or videos.
 *
 * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector
 */ class $bd6a3ece56e4d687$export$f21d9483ebeee00a {
    static async polyfill() {
        if (!('BarcodeDetector' in window)) try {
            await (parcelRequire("3jPiW"));
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).info('Using BarcodeDetector polyfill.');
        } catch (error) {
            throw new Error('BarcodeDetector API is not supported by your browser.', {
                cause: error
            });
        }
        else (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).info('Using the native BarcodeDetector API.');
    }
    /**
   * Get the supported barcode formats.
   *
   * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector/getSupportedFormats
   * @returns {Promise<Array<string>>} A promise that resolves to an array of supported barcode formats.
   */ static async getSupportedFormats() {
        const nativeSupportedFormats = await window.BarcodeDetector.getSupportedFormats() || [];
        return $bd6a3ece56e4d687$var$WHITELISTED_FORMATS.filter((format)=>nativeSupportedFormats.includes(format));
    }
    /**
   * Create a new BarcodeReader instance.
   *
   * @param {Array<string>} supportedFormats - A list of supported barcode formats. If not provided, it will use the default supported formats.
   * @returns {Promise<BarcodeReader>} A promise that resolves to a new BarcodeReader instance.
   */ static async create(supportedFormats) {
        const isValidFormats = Array.isArray(supportedFormats) && supportedFormats.length > 0;
        const formats = isValidFormats ? supportedFormats : await $bd6a3ece56e4d687$export$f21d9483ebeee00a.getSupportedFormats();
        return new $bd6a3ece56e4d687$export$f21d9483ebeee00a(formats);
    }
    /**
   * Sets up BarcodeReader by polyfilling the BarcodeDetector API if needed.
   *
   * @returns {Promise<{barcodeReaderError: Error}>} A promise that resolves to an object containing any error encountered during setup.
   */ static async setup() {
        try {
            await $bd6a3ece56e4d687$export$f21d9483ebeee00a.polyfill();
            return {
                barcodeReaderError: null
            };
        } catch (error) {
            return {
                barcodeReaderError: error
            };
        }
    }
    /**
   * Create a new BarcodeReader instance.
   *
   * @param {Array<string>} formats - Supported barcode formats
   */ constructor(formats){
        this.barcodeReader = new window.BarcodeDetector({
            formats: formats
        });
    }
    /**
   * Detect barcodes from the provided source.
   *
   * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector/detect
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap} source - Image or video element or ImageBitmap.
   * @returns {Promise<DetectedBarcode>} A promise that resolves to the first detected barcode.
   */ async detect(source) {
        if (!this.barcodeReader) throw new Error('BarcodeReader is not initialized.');
        const results = await this.barcodeReader.detect(source);
        if (Array.isArray(results) && results.length > 0) {
            const firstResult = results[0];
            (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).info({
                rawValue: firstResult.rawValue,
                format: firstResult.format
            });
            return firstResult;
        } else throw new Error('Could not detect barcode from provided source.');
    }
}




function $3bec24ea88debbaf$var$getRequiredElement(selector, root = document) {
    const element = root.querySelector(selector);
    if (!element) throw new Error(`Required element not found: ${selector}`);
    return element;
}
function $3bec24ea88debbaf$export$c69d95bd74c1753c() {
    return {
        tabsEl: $3bec24ea88debbaf$var$getRequiredElement('a-tab-group'),
        cameraScannerEl: $3bec24ea88debbaf$var$getRequiredElement('camera-scanner'),
        cameraScannerResultsEl: $3bec24ea88debbaf$var$getRequiredElement('#cameraScannerResults'),
        fileScannerEl: $3bec24ea88debbaf$var$getRequiredElement('file-scanner'),
        fileScannerResultsEl: $3bec24ea88debbaf$var$getRequiredElement('#fileScannerResults'),
        historyEl: $3bec24ea88debbaf$var$getRequiredElement('scan-history'),
        historyButtonEl: $3bec24ea88debbaf$var$getRequiredElement('#historyButton'),
        historyDialogEl: $3bec24ea88debbaf$var$getRequiredElement('#historyDialog'),
        scanSettingsEl: $3bec24ea88debbaf$var$getRequiredElement('scan-settings'),
        settingsButtonEl: $3bec24ea88debbaf$var$getRequiredElement('#settingsButton'),
        settingsDialogEl: $3bec24ea88debbaf$var$getRequiredElement('#settingsDialog'),
        settingsFormEl: $3bec24ea88debbaf$var$getRequiredElement('#settingsForm'),
        appActionsEl: $3bec24ea88debbaf$var$getRequiredElement('#appActions')
    };
}


/**
 * Creates a controller to manage the visibility of the camera scanner based on
 * tab selection and document visibility.
 *
 * @param {{tabsEl: HTMLElement, cameraScannerEl: HTMLElement}} params - Controller dependencies.
 * @returns {Function} A function that removes the controller's event listeners.
 */ function $834bfe0e4ae89716$export$99956b94b93d6607({ tabsEl: tabsEl, cameraScannerEl: cameraScannerEl }) {
    function dispatchCameraScannerVisibilityChange(cameraScannerEl, detail) {
        cameraScannerEl.dispatchEvent(new CustomEvent('camera-scanner-visibility-change', {
            bubbles: true,
            composed: true,
            detail: detail
        }));
    }
    function handleTabShow(evt) {
        const tabId = evt.detail.tabId;
        if (tabId === 'cameraTab') dispatchCameraScannerVisibilityChange(cameraScannerEl, {
            reason: 'tab-change',
            visibility: 'visible'
        });
        if (tabId === 'fileTab') dispatchCameraScannerVisibilityChange(cameraScannerEl, {
            reason: 'tab-change',
            visibility: 'hidden'
        });
    }
    function handleDocumentVisibilityChange() {
        const selectedTab = tabsEl.querySelector('[selected]');
        const tabId = selectedTab.getAttribute('id');
        if (tabId !== 'cameraTab') return;
        dispatchCameraScannerVisibilityChange(cameraScannerEl, {
            reason: 'page-visibility-change',
            visibility: document.visibilityState === 'hidden' ? 'hidden' : 'visible'
        });
    }
    tabsEl.addEventListener('a-tab-show', handleTabShow);
    document.addEventListener('visibilitychange', handleDocumentVisibilityChange);
    return function destroyScannerVisibilityController() {
        tabsEl.removeEventListener('a-tab-show', handleTabShow);
        document.removeEventListener('visibilitychange', handleDocumentVisibilityChange);
    };
}




/**
 * Creates and shows the scanned result inside the given element.
 *
 * @param {HTMLElement} containerEl - The element to show the result in.
 * @param {string} value - The value to create the result with.
 */ async function $029405621f22d395$export$587bdd19f8501571(containerEl, value) {
    if (!containerEl || !value) return;
    // Avoid using querySelector with attribute selectors here because `value` may
    // contain newlines or other characters that make the selector invalid.
    // Instead, query all results and match the attribute value in JS.
    const existingResultEls = Array.from(containerEl.querySelectorAll('scan-result'));
    const matchingResultEl = existingResultEls.find((el)=>el.getAttribute('value') === value);
    if (matchingResultEl) matchingResultEl.remove();
    const newResultEl = document.createElement('scan-result');
    newResultEl.setAttribute('value', value);
    newResultEl.setAttribute('role', 'alert');
    containerEl.insertBefore(newResultEl, containerEl.firstElementChild);
    containerEl.scrollTop = 0;
}


/**
 * Beep sound using the `AudioContext` interface.
 *
 * @param {Object} options - The options for the beep sound.
 * @param {Number} options.duration - The duration in milliseconds.
 * @param {Number} options.frequency - the frequency in Hz.
 * @param {Number} options.volume - The volume (0.0 to 1.0).
 * @param {String} options.type - the type of oscillator.
 * @param {Function} options.onEnded - Callback function to be called when the beep sound ends.
 */ const $03108407b3445b97$export$d6c943e433460aae = (()=>{
    const audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext)();
    if (!audioCtx) return;
    return (options)=>{
        const { duration: duration, frequency: frequency, volume: volume, type: type, onEnded: onEnded } = options;
        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);
        if (volume) gainNode.gain.value = volume;
        if (frequency) oscillator.frequency.value = frequency;
        if (type) oscillator.type = type;
        if (typeof onEnded === 'function') oscillator.onended = onEnded;
        oscillator.start(audioCtx.currentTime);
        oscillator.stop(audioCtx.currentTime + (duration || 500) / 1000);
    };
})();


/**
 * Vibrate the device.
 * If the device does not support vibration, this function will fail silently.
 *
 * @param {Number} [duration=0] - The duration in milliseconds.
 */ async function $a9907c53eaf95c94$export$3ca8e905da0a0ca8(duration = 0) {
    if (typeof window.navigator.vibrate !== 'function') return;
    try {
        window.navigator.vibrate(duration);
    } catch  {
    // Fail silently...
    }
}



const $bcbd188dfb2c1fe9$var$RATE_LIMIT = 1000;
let $bcbd188dfb2c1fe9$var$lastTriggerTime = 0;
async function $bcbd188dfb2c1fe9$export$9b466d13e2031a67(options = {}) {
    const { success: success = true } = options;
    const [, settings] = await (0, $446905cc56717322$export$4a647155031ece)();
    if (!settings) return;
    const now = Date.now();
    if (now - $bcbd188dfb2c1fe9$var$lastTriggerTime < $bcbd188dfb2c1fe9$var$RATE_LIMIT) return;
    const beepConfig = success ? {
        duration: 200,
        frequency: 860,
        volume: 0.03,
        type: 'square'
    } : {
        duration: 300,
        frequency: 200,
        volume: 0.05,
        type: 'sawtooth'
    };
    settings.beep && (0, $03108407b3445b97$export$d6c943e433460aae)(beepConfig);
    settings.vibrate && (0, $a9907c53eaf95c94$export$3ca8e905da0a0ca8)(success ? 100 : 200);
    $bcbd188dfb2c1fe9$var$lastTriggerTime = now;
}



function $3303985f7d77cab1$export$c1a8220d0f9d68fc({ cameraScannerEl: cameraScannerEl, cameraScannerResultsEl: cameraScannerResultsEl, fileScannerEl: fileScannerEl, fileScannerResultsEl: fileScannerResultsEl, historyEl: historyEl }) {
    async function handleBarcodeDetectSuccess(evt) {
        const { barcodeValue: barcodeValue, source: source } = evt.detail;
        const resultsEl = source === 'camera-scanner' ? cameraScannerResultsEl : fileScannerResultsEl;
        (0, $029405621f22d395$export$587bdd19f8501571)(resultsEl, barcodeValue);
        const [, settings] = await (0, $446905cc56717322$export$4a647155031ece)();
        if (settings?.addToHistory) historyEl.add(barcodeValue);
        (0, $bcbd188dfb2c1fe9$export$9b466d13e2031a67)();
    }
    async function handleBarcodeDetectError(evt) {
        const { error: error } = evt.detail;
        (0, $f272c8d1b34cbe13$export$bef1f36f5486a6a3).error(error);
        (0, $1531977e7a058bbb$export$cbcbdc571577a620)('<strong>No barcode detected</strong><br><small>Please try again with a different image.</small>', {
            variant: 'danger',
            announce: 'alert',
            trustDangerousInnerHTML: true
        });
        (0, $bcbd188dfb2c1fe9$export$9b466d13e2031a67)({
            success: false
        });
    }
    cameraScannerEl.addEventListener('barcode-detect-success', handleBarcodeDetectSuccess);
    fileScannerEl.addEventListener('barcode-detect-success', handleBarcodeDetectSuccess);
    fileScannerEl.addEventListener('barcode-detect-error', handleBarcodeDetectError);
    return function destroyBarcodeDetectionController() {
        cameraScannerEl.removeEventListener('barcode-detect-success', handleBarcodeDetectSuccess);
        fileScannerEl.removeEventListener('barcode-detect-success', handleBarcodeDetectSuccess);
        fileScannerEl.removeEventListener('barcode-detect-error', handleBarcodeDetectError);
    };
}



/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * 'n' milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {function} fn The function to be executed.
 * @param {Number} [wait=0] Time of delay in milliseconds. It is required if `immediate` is used.
 * @param {Boolean} [immediate=false] If true or any truthy value, triggers the function on the leading edge.
 * @throws {TypeError} If `fn` is not function.
 * @returns {function} A new debounced function.
 * @example
 *
 * const debouncedHandler = debounce(() => {
 *   // Do your thing here...
 * }, 250);
 *
 * window.addEventListener('resize', debouncedHandler, false);
 */ function $42ef69457c533b36$export$61fc7d43ac8f84b0(fn, wait = 0, immediate = false) {
    let timerId = null;
    if (typeof fn !== 'function') throw new TypeError('Expected a function for first argument');
    return (...args)=>{
        clearTimeout(timerId);
        if (immediate && !timerId) fn(...args);
        timerId = setTimeout(()=>{
            timerId = null;
            if (!immediate) fn(...args);
        }, wait);
    };
}


function $2381d12e96636399$export$47f43cf9d7732c0d({ settingsDialogEl: settingsDialogEl, settingsButtonEl: settingsButtonEl, settingsFormEl: settingsFormEl, onFormatsChange: onFormatsChange }) {
    function handleSettingsButtonClick() {
        settingsDialogEl.open = true;
    }
    async function handleSettingsFormChange(evt) {
        evt.preventDefault();
        const nextSettings = {};
        const formData = new FormData(settingsFormEl);
        const generalSettings = formData.getAll('general-settings');
        const scanSettings = formData.getAll('formats-settings');
        generalSettings.forEach((value)=>{
            nextSettings[value] = true;
        });
        nextSettings.formats = scanSettings;
        await (0, $446905cc56717322$export$dc86d17a64679bc7)(nextSettings);
        if (evt.target.name === 'formats-settings') await onFormatsChange(scanSettings);
    }
    settingsButtonEl.addEventListener('click', handleSettingsButtonClick);
    settingsFormEl.addEventListener('change', (0, $42ef69457c533b36$export$61fc7d43ac8f84b0)(handleSettingsFormChange, 500));
    return function destroySettingsController() {
        settingsButtonEl.removeEventListener('click', handleSettingsButtonClick);
        settingsFormEl.removeEventListener('change', (0, $42ef69457c533b36$export$61fc7d43ac8f84b0)(handleSettingsFormChange, 500));
    };
}



function $afda4bf161775b46$export$57ea43eaf0c1342e({ historyButtonEl: historyButtonEl, historyDialogEl: historyDialogEl }) {
    function handleHistoryButtonClick() {
        historyDialogEl.open = true;
    }
    function handleHistoryError(evt) {
        const { type: type, message: message } = evt.detail;
        if (type === 'remove' || type === 'empty') historyDialogEl.hide();
        (0, $1531977e7a058bbb$export$cbcbdc571577a620)(message, {
            variant: 'danger',
            announce: 'alert'
        });
    }
    historyButtonEl.addEventListener('click', handleHistoryButtonClick);
    document.addEventListener('scan-history-error', handleHistoryError);
    return function destroyHistoryController() {
        historyButtonEl.removeEventListener('click', handleHistoryButtonClick);
        document.removeEventListener('scan-history-error', handleHistoryError);
    };
}


async function $58425667c4c73a4f$export$36aff1fbb4f5dfc6() {
    const { tabsEl: tabsEl, cameraScannerEl: cameraScannerEl, cameraScannerResultsEl: cameraScannerResultsEl, fileScannerEl: fileScannerEl, fileScannerResultsEl: fileScannerResultsEl, historyEl: historyEl, historyButtonEl: historyButtonEl, historyDialogEl: historyDialogEl, scanSettingsEl: scanSettingsEl, settingsButtonEl: settingsButtonEl, settingsDialogEl: settingsDialogEl, settingsFormEl: settingsFormEl, appActionsEl: appActionsEl } = (0, $3bec24ea88debbaf$export$c69d95bd74c1753c)();
    // By default the dialog elements are hidden for browsers that don't support the dialog element.
    // If the dialog element is supported, we remove the hidden attribute and the dialogs' visibility
    // is controlled by using the `showModal()` and `close()` methods.
    if (typeof HTMLDialogElement === 'function') {
        appActionsEl.removeAttribute('hidden');
        historyDialogEl.removeAttribute('hidden');
        settingsDialogEl.removeAttribute('hidden');
    }
    const { barcodeReaderError: barcodeReaderError } = await (0, $bd6a3ece56e4d687$export$f21d9483ebeee00a).setup();
    if (barcodeReaderError) {
        appActionsEl.setAttribute('hidden', '');
        tabsEl.setAttribute('hidden', '');
        const errorMessage = /* html */ `
      <strong>Barcode Detector API not supported</strong>
      <br>
      Your browser does not support the Barcode Detector API, which is required for this application to work.
    `;
        (0, $1531977e7a058bbb$export$cbcbdc571577a620)(errorMessage, {
            variant: 'danger',
            announce: 'alert',
            trustDangerousInnerHTML: true,
            duration: Infinity
        });
        // Stop the script execution as BarcodeDetector API is not supported.
        return;
    }
    const supportedBarcodeFormats = await (0, $bd6a3ece56e4d687$export$f21d9483ebeee00a).getSupportedFormats();
    const [, settings] = await (0, $446905cc56717322$export$4a647155031ece)();
    const initialFormats = settings?.formats || supportedBarcodeFormats;
    let barcodeReader = await (0, $bd6a3ece56e4d687$export$f21d9483ebeee00a).create(initialFormats);
    cameraScannerEl.barcodeReader = barcodeReader;
    fileScannerEl.barcodeReader = barcodeReader;
    scanSettingsEl.supportedFormats = supportedBarcodeFormats;
    (0, $834bfe0e4ae89716$export$99956b94b93d6607)({
        tabsEl: tabsEl,
        cameraScannerEl: cameraScannerEl
    });
    (0, $3303985f7d77cab1$export$c1a8220d0f9d68fc)({
        cameraScannerEl: cameraScannerEl,
        cameraScannerResultsEl: cameraScannerResultsEl,
        fileScannerEl: fileScannerEl,
        fileScannerResultsEl: fileScannerResultsEl,
        historyEl: historyEl
    });
    (0, $afda4bf161775b46$export$57ea43eaf0c1342e)({
        historyButtonEl: historyButtonEl,
        historyDialogEl: historyDialogEl
    });
    (0, $2381d12e96636399$export$47f43cf9d7732c0d)({
        settingsDialogEl: settingsDialogEl,
        settingsButtonEl: settingsButtonEl,
        settingsFormEl: settingsFormEl,
        onFormatsChange: async (formats)=>{
            barcodeReader = await (0, $bd6a3ece56e4d687$export$f21d9483ebeee00a).create(formats);
            cameraScannerEl.barcodeReader = barcodeReader;
            fileScannerEl.barcodeReader = barcodeReader;
        }
    });
}


(0, $be80c1b207286e9d$export$e73a9d346ce244ee)();
(0, $58425667c4c73a4f$export$36aff1fbb4f5dfc6)();


//# sourceMappingURL=barcode-scanner.eb827bde.js.map
